export const translations = {
  en: {
    // Navbar
    nav_tech: "Technology",
    nav_samples: "Samples",
    nav_pricing: "Pricing",
    nav_services: "Services",
    nav_demo_btn: "FREE DEMO",
    nav_chat_wa: "CHAT ON WHATSAPP",

    // Hero Section
    hero_title_prefix: "No anchor. No studio. No editor.",
    hero_title_suffix: "Your news channel, fully powered by AI.",
    hero_extra: "Breaking news delivered in 25 minutes — not 2 hours.",
    hero_tagline: "Professional news videos with an AI anchor — your face, your voice, your brand.",
    hero_subtext: "Revolutionize your digital newsroom with next-generation AI anchors.",
    hero_hindi_detail: "Start your news channel today without a studio, camera, or human anchor.",
    hero_btn_samples: "View Samples",
    hero_btn_pricing: "Pricing Plans",
    hero_ticker: " • NO STUDIO REQUIRED • 100+ LANGUAGES SUPPORTED • 4K AI ANCHORS READY • START YOUR CHANNEL TODAY • NO CAMERA NEEDED • ",

    // About / Feature Powerhouse
    about_badge: "WHAT WE DO",
    about_title: "Run a complete news channel without an anchor, studio, or editor.",
    about_title_accent: "From news to video in just 25 minutes.",
    about_sublead: "No studio. No anchor salary. No production headache. Ready to publish on YouTube, Facebook, and beyond.",
    about_vision_heading: "We don’t just create videos.",
    about_vision_span: "We build fully automated digital news channels.",
    about_desc1: "Ananta Infotech is a news editing agency powered by artificial intelligence. We help small and independent news channels produce broadcast-quality video content — fast, affordable, and without a full production team.",
    about_desc2: "Whether you need a daily news video with a generic AI anchor or a personalised anchor that looks and sounds exactly like you, we handle everything from editing to delivery.",

    // Features
    feat_ai_title: "Hyper-realistic AI Anchors",
    feat_ai_desc: "State-of-the-art neural avatars with human-like expressions and perfect lip-sync.",
    feat_prod_title: "Daily Video Production",
    feat_prod_desc: "Fresh, relevant news content delivered to your dashboard every single day.",
    feat_vis_title: "Professional Visuals",
    feat_vis_desc: "Virtual studios and high-end news graphics that rival national TV networks.",
    feat_deliv_title: "Fast Delivery",
    feat_deliv_desc: "Go from script to broadcast-ready video in minutes, not hours.",
    feat_dep_title: "Zero Dependency",
    feat_dep_desc: "No more waiting for anchors or editors. Your channel runs 24/7 on autopilot.",
    promo_badge: "Start Your Empire",
    promo_text: "Take the leap into the future of digital journalism.",
    promo_btn: "Get Started",

    // How It Works
    how_title: "How It Works",
    how_step1_title: "Send Content",
    how_step1_desc: "Send us your footage, audio, and script.",
    how_step2_title: "AI Processing",
    how_step2_desc: "Our team and AI system process and edit your content.",
    how_step3_title: "Fast Delivery",
    how_step3_desc: "Your ready-to-publish news video is delivered in 25 minutes.",

    // Why Us / Comparison
    why_title: "Why",
    why_accent: "Ananta?",
    why_subtitle: "Because your competition is still doing this manually.",
    why_old_badge: "THE OLD STRUGGLE",
    why_old_heading: "Manual Production",
    why_old_p1: "Expensive Anchors",
    why_old_p1_cost: "₹25k–₹50k/mo",
    why_old_p2: "High Studio Setup Costs",
    why_old_p3: "Delayed Production & Editing",
    why_new_badge: "BETTER VALUE",
    why_new_heading: "Ananta AI Powerhouse",
    why_new_p1_title: "Fraction of Cost",
    why_new_p1_desc: "Daily news videos without the massive payroll. Plans starting at just ₹5,500 per month.",
    why_new_p2_title: "Consistent Output",
    why_new_p2_desc: "No more human delays. 24/7 reliability.",
    why_new_p3_title: "Scalable Production",
    why_new_p3_desc: "Grow from 1 to 100 videos effortlessly.",
    why_new_p4_title: "Pro Branding",
    why_new_p4_desc: "National-TV visuals from the first second.",
    why_usp_point: "From 2 hours to 25 minutes — that's the difference we make. No studio setup needed. No full-time editor on payroll. AI anchor with your own face and voice — available at a fraction of the cost.",

    // Plans / Pricing
    pricing_title: "Our",
    pricing_title_accent: "Pricing Plans",
    plan_standard_title: "Standard AI Anchor Plans",
    plan_standard_desc: "Professional news videos with a high-quality AI anchor. Perfect for channels looking to scale their output without hiring a production team.",
    plan_realface_title: "Real Face AI Anchor Plans",
    plan_realface_desc: "Your face. Your voice. Cloned into an AI anchor that represents your channel's identity on screen — every single video.",
    
    plan_starter_name: "Starter Plan",
    plan_starter_price: "₹5,500",
    plan_starter_duration: "/ Month",
    plan_starter_tagline: "Perfect for local and growing digital channels",
    plan_starter_f1: "3 videos daily, up to 5 minutes each",
    plan_starter_f2: "Professional AI anchor",
    plan_starter_f3: "News visual integration",
    plan_starter_f4: "Custom branding & HD output",

    plan_growth_name: "Growth Plan",
    plan_growth_price: "₹10,000",
    plan_growth_duration: "/ Month",
    plan_growth_tagline: "Designed for channels publishing multiple updates daily",
    plan_growth_f1: "6 videos daily, up to 5 minutes each",
    plan_growth_f2: "Priority processing & fast delivery",
    plan_growth_f3: "News visual integration",
    plan_growth_f4: "Custom branding & HD output",

    plan_personal_name: "Personal AI Anchor",
    plan_personal_price: "₹7,500",
    plan_personal_duration: "/ Month",
    plan_personal_tagline: "Turn your own face & voice into a professional AI presenter",
    plan_personal_f1: "3 videos daily, up to 5 minutes each",
    plan_personal_f2: "Your face clone",
    plan_personal_f3: "Your voice clone",
    plan_personal_f4: "Custom branding & HD output",

    plan_premium_personal_name: "Premium Personal AI Anchor",
    plan_premium_personal_price: "₹13,000",
    plan_premium_personal_duration: "/ Month",
    plan_premium_personal_tagline: "High-volume production with personalized AI identity",
    plan_premium_personal_f1: "6 videos daily, up to 5 minutes each",
    plan_premium_personal_f2: "Your face clone & voice clone",
    plan_premium_personal_f3: "Priority processing & dedicated support",
    plan_premium_personal_f4: "Dedicated support & HD output",

    plan_custom_name: "Custom / Enterprise",
    plan_custom_desc: "Need more videos? Custom plans are available for media houses, digital publishers, political organisations, and content networks requiring higher daily production volumes.",
    plan_custom_btn: "Contact Us",

    // Self Edit App Section
    app_badge: "COMING SOON",
    app_title: "News Editor App",
    app_desc1: "Take full control of your content. Our AI-powered app lets news channel owners build and publish their own videos using ready-made templates — no technical skills needed.",
    app_desc2: "Upload your audio, footage, B-roll, and headings. The app generates a publish-ready news video automatically.",
    app_price_tag: "Launching at just ₹1,000/month.",
    app_btn: "Get Notified",

    // Testimonial / Feedback
    feedback_badge: "SUCCESS STORIES",
    feedback_title: "Trusted by",
    feedback_title_accent: "Digital Newsrooms",
    feedback_q1: "We were spending over 2 hours on every news video. Now it's done in 25 minutes — and it looks more professional than before.",
    feedback_a1_role: "News Channel Owner, Uttar Pradesh",

    // CTA
    cta_title: "Ready to transform your news channel?",
    cta_subtitle: "Get your first video in 25 minutes.",
    cta_btn: "Contact us today — limited slots available.",

    // Footer
    footer_tagline: "Ananta Infotech — AI-powered news, delivered fast.",
    footer_desc: "Empowering the next generation of digital newsrooms with hyper-realistic AI Anchors.",
    footer_links: "Quick Links",
    footer_contact: "Contact",
    footer_rights: "© 2026 Ananta Infotech. All rights reserved."
  },
  hi: {
    // Navbar
    nav_tech: "टेक्नोलॉजी",
    nav_samples: "सैंपल्स",
    nav_pricing: "प्लान्स",
    nav_services: "सर्विसेज",
    nav_demo_btn: "फ्री डेमो",
    nav_chat_wa: "व्हाट्सएप चैट",

    // Hero Section
    hero_title_prefix: "न एंकर, न स्टूडियो, न एडिटर।",
    hero_title_suffix: "आपका न्यूज चैनल — पूरी तरह AI से चलाइए।",
    hero_extra: "ब्रेकिंग न्यूज़ — 2 घंटे नहीं, सिर्फ 25 मिनट में।",
    hero_tagline: "प्रोफेशनल न्यूज वीडियो, AI एंकर के साथ — आपका चेहरा, आपकी आवाज़, आपका ब्रांड।",
    hero_subtext: "नेक्स्ट-जेनरेशन AI एंकर के साथ अपने डिजिटल न्यूज़रूम में क्रांति लाएं।",
    hero_hindi_detail: "बिना स्टूडियो, बिना कैमरा और बिना ह्यूमन एंकर के आज ही अपना न्यूज़ चैनल शुरू करें।",
    hero_btn_samples: "सैंपल्स देखें",
    hero_btn_pricing: "प्राइसिंग प्लान्स",
    hero_ticker: " • कोई स्टूडियो की ज़रूरत नहीं • 100+ भाषाएं उपलब्ध • 4K AI एंकर तैयार • आज ही अपना चैनल शुरू करें • कोई कैमरा नहीं चाहिए • ",

    // About / Feature Powerhouse
    about_badge: "हम क्या करते हैं",
    about_title: "बिना एंकर, बिना स्टूडियो, बिना एडिटर पूरा न्यूज चैनल चलाइए।",
    about_title_accent: "खबर से वीडियो तक सिर्फ 25 मिनट।",
    about_sublead: "कोई स्टूडियो नहीं। कोई एंकर सैलरी नहीं। कोई प्रोडक्शन का सिरदर्द नहीं। यूट्यूब, फेसबुक और अन्य प्लेटफॉर्म्स पर पब्लिश करने के लिए तैयार।",
    about_vision_heading: "हम सिर्फ वीडियो नहीं बनाते।",
    about_vision_span: "हम पूरी तरह से ऑटोमेटेड डिजिटल न्यूज चैनल बनाते हैं।",
    about_desc1: "Ananta Infotech एक AI-संचालित न्यूज एडिटिंग एजेंसी है। हम छोटे और स्वतंत्र न्यूज चैनलों को प्रोफेशनल क्वालिटी के वीडियो बनाने में मदद करते हैं — तेज़, किफायती, और बिना पूरी प्रोडक्शन टीम के।",
    about_desc2: "चाहे आपको जेनेरिक AI एंकर के साथ डेली न्यूज वीडियो चाहिए, या एक पर्सनलाइज्ड एंकर जो बिल्कुल आप जैसा दिखे और बोले — हम शुरू से आखिर तक सब संभालते हैं।",

    // Features
    feat_ai_title: "अति-यथार्थवादी AI एंकर",
    feat_ai_desc: "मानव जैसे हाव-भाव और सटीक लिप-सिंक वाले अत्याधुनिक न्यूरल अवतार।",
    feat_prod_title: "डेली वीडियो प्रोडक्शन",
    feat_prod_desc: "हर दिन आपके डैशबोर्ड पर ताज़ा और प्रासंगिक समाचार वीडियो पहुंचाए जाते हैं।",
    feat_vis_title: "प्रोफेशनल विजुअल्स",
    feat_vis_desc: "नेशनल टीवी चैनलों को टक्कर देने वाले वर्चुअल स्टूडियो और हाई-एंड न्यूज ग्राफिक्स।",
    feat_deliv_title: "फास्ट डिलीवरी",
    feat_deliv_desc: "स्क्रिप्ट से सीधे ब्रॉडकास्ट-रेडी वीडियो मिनटों में, घंटों में नहीं।",
    feat_dep_title: "जीरो डिपेंडेंसी",
    feat_dep_desc: "एंकर या एडिटर के लिए अब कोई इंतजार नहीं। आपका चैनल 24/7 ऑटोपायलट पर चलेगा।",
    promo_badge: "अपना साम्राज्य शुरू करें",
    promo_text: "डिजिटल पत्रकारिता के भविष्य में कदम रखें।",
    promo_btn: "शुरू करें",

    // How It Works
    how_title: "यह कैसे काम करता है",
    how_step1_title: "कंटेंट भेजें",
    how_step1_desc: "अपना फुटेज, ऑडियो और स्क्रिप्ट हमें भेजें।",
    how_step2_title: "AI प्रोसेसिंग",
    how_step2_desc: "हमारी टीम और AI सिस्टम आपके कंटेंट को प्रोसेस और एडिट करता है।",
    how_step3_title: "तेज डिलीवरी",
    how_step3_desc: "25 मिनट में पब्लिश-रेडी न्यूज वीडियो आपके पास।",

    // Why Us / Comparison
    why_title: "क्यों",
    why_accent: "अनंता?",
    why_subtitle: "क्योंकि आपका कॉम्पिटिशन अभी भी इसे मैन्युअल रूप से कर रहा है।",
    why_old_badge: "पुरानी परेशानियां",
    why_old_heading: "मैनुअल प्रोडक्शन",
    why_old_p1: "महंगे एंकर",
    why_old_p1_cost: "₹25k–₹50k/माह",
    why_old_p2: "हाई स्टूडियो सेटअप खर्च",
    why_old_p3: "देरी से प्रोडक्शन और एडिटिंग",
    why_new_badge: "बेहतर वैल्यू",
    why_new_heading: "अनंता AI पावरहाउस",
    why_new_p1_title: "किफायती लागत",
    why_new_p1_desc: "बिना भारी वेतन खर्च के दैनिक समाचार वीडियो। प्लान सिर्फ ₹5,500 प्रति माह से शुरू।",
    why_new_p2_title: "कंसिस्टेंट आउटपुट",
    why_new_p2_desc: "अब इंसानी देरी नहीं। 24/7 विश्वसनीयता।",
    why_new_p3_title: "स्केलेबल प्रोडक्शन",
    why_new_p3_desc: "1 से 100 वीडियो तक आसानी से प्रोडक्शन बढ़ाएं।",
    why_new_p4_title: "प्रो ब्रांडिंग",
    why_new_p4_desc: "पहले सेकंड से नेशनल-टीवी जैसे विज़ुઅल्स।",
    why_usp_point: "2 घंटे से 25 मिनट — यही है हमारा फर्क। कोई स्टूडियो सेटअप नहीं चाहिए। कोई फुल-टाइम एडिटर की ज़रूरत नहीं। आपके चेहरे और आवाज़ वाला AI एंकर — बेहद किफायती कीमत पर।",

    // Plans / Pricing
    pricing_title: "हमारे",
    pricing_title_accent: "प्राइसिंग प्लान्स",
    plan_standard_title: "Standard AI Anchor Plans",
    plan_standard_desc: "हाई-क्वालिटी AI एंकर के साथ प्रोफेशनल न्यूज वीडियो। उन चैनलों के लिए जो बिना प्रोडक्शन टीम के अपना डेली आउटपुट बढ़ाना चाहते हैं।",
    plan_realface_title: "Real Face AI Anchor Plans",
    plan_realface_desc: "आपका चेहरा। आपकी आवाज़। AI एंकर में क्लोन — जो हर वीडियो में आपके चैनल की पहचान बने।",
    
    plan_starter_name: "Starter Plan",
    plan_starter_price: "₹5,500",
    plan_starter_duration: "/ माह",
    plan_starter_tagline: "लोकल और ग्रोइंग डिजिटल चैनलों के लिए उपयुक्त",
    plan_starter_f1: "रोज़ 3 वीडियो, हर एक अप टू 5 मिनट",
    plan_starter_f2: "प्रोफेशनल AI एंकर",
    plan_starter_f3: "न्यूज विज़ुअल इंटीग्रेशन",
    plan_starter_f4: "कस्टम ब्रांडिंग और HD आउटपुट",

    plan_growth_name: "Growth Plan",
    plan_growth_price: "₹10,000",
    plan_growth_duration: "/ माह",
    plan_growth_tagline: "उन चैनलों के लिए जो हर दिन कई अपडेट पब्लिश करते हैं",
    plan_growth_f1: "रोज़ 6 वीडियो, हर एक अप टू 5 मिनट",
    plan_growth_f2: "प्रायोरिटी प्रोसेसिंग और तेज डिलीवरी",
    plan_growth_f3: "न्यूज विज़ुअल इंटीग्रेशन",
    plan_growth_f4: "कस्टम ब्रांडिंग और HD आउटपुट",

    plan_personal_name: "Personal AI Anchor",
    plan_personal_price: "₹7,500",
    plan_personal_duration: "/ माह",
    plan_personal_tagline: "अपने चेहरे और आवाज़ को एक प्रोफेशनल AI प्रेज़ेंटर में बदलें",
    plan_personal_f1: "रोज़ 3 वीडियो, हर एक अप टू 5 मिनट",
    plan_personal_f2: "आपका फेस क्लोन",
    plan_personal_f3: "आपकी आवाज़ का क्लोन",
    plan_personal_f4: "कस्टम ब्रांडिंग और HD आउटपुट",

    plan_premium_personal_name: "Premium Personal AI Anchor",
    plan_premium_personal_price: "₹13,000",
    plan_premium_personal_duration: "/ माह",
    plan_premium_personal_tagline: "पर्सनलाइज्ड AI पहचान के साथ हाई-वॉल्यूम प्रोडक्शन",
    plan_premium_personal_f1: "रोज़ 6 वीडियो, हर एक अप टू 5 मिनट",
    plan_premium_personal_f2: "आपका फेस और वॉयस क्लोन",
    plan_premium_personal_f3: "प्रायोरिटी प्रोसेसिंग और समर्पित सपोर्ट",
    plan_premium_personal_f4: "डेडिकेटेड सपोर्ट और HD आउटपुट",

    plan_custom_name: "कस्टम / एंटरप्राइज",
    plan_custom_desc: "ज़्यादा वीडियो चाहिए? मीडिया हाउस, डिजिटल पब्लिशर, राजनीतिक संगठनों और कंटेंट नेटवर्क के लिए कस्टम एंटरप्राइज प्लान उपलब्ध हैं।",
    plan_custom_btn: "संपर्क करें",

    // Self Edit App Section
    app_badge: "जल्द आ रहा है",
    app_title: "News Editor App",
    app_desc1: "अपने कंटेंट की पूरी कमान अपने हाथ में लीजिए। हमारा AI-पावर्ड ऐप न्यूज चैनल ओनर्स को रेडीमेड टेम्पलेट्स से अपने वीडियो खुद बनाने और पब्लिश करने की सुविधा देता है — कोई तकनीकी जानकारी ज़रूरी नहीं।",
    app_desc2: "अपना ऑडियो, फुटेज, बी-रोल और हेडिंग अपलोड करें। ऐप अपने आप पब्लिश-रेडी न्यूज वीडियो तैयार कर देगा।",
    app_price_tag: "सिर्फ ₹1,000/माह में लॉन्च होगा।",
    app_btn: "सूचना पाएं",

    // Testimonial / Feedback
    feedback_badge: "सफलता की कहानियां",
    feedback_title: "भरोसा",
    feedback_title_accent: "डिजिटल न्यूज़रूम का",
    feedback_q1: "हर न्यूज वीडियो में 2 घंटे से ज़्यादा लग जाते थे। अब 25 मिनट में हो जाता है — और पहले से ज़्यादा प्रोफेशनल भी दिखता है।",
    feedback_a1_role: "न्यूज चैनल ओनर, उत्तर प्रदेश",

    // CTA
    cta_title: "अपने न्यूज चैनल को बदलने के लिए तैयार हैं?",
    cta_subtitle: "पहला वीडियो 25 मिनट में पाइए।",
    cta_btn: "आज ही संपर्क करें — सीमित सीटें उपलब्ध हैं।",

    // Footer
    footer_tagline: "Ananta Infotech — AI से चलने वाला न्यूज, तेज़ डिलीवरी के साथ।",
    footer_desc: "अति-यथार्थवादी AI एंकर के साथ डिजिटल न्यूज़रूम की नई पीढ़ी को सशक्त बनाना।",
    footer_links: "त्वरित लिंक्स",
    footer_contact: "संपर्क",
    footer_rights: "© 2026 Ananta Infotech. सभी अधिकार सुरक्षित।"
  },
  mr: {
    // Marathi (मराठी)
    nav_tech: "तंत्रज्ञान",
    nav_samples: "नमुने",
    nav_pricing: "दरपत्रक",
    nav_services: "सेवा",
    nav_demo_btn: "फ्री डेमो",
    nav_chat_wa: "व्हाट्सॲप चॅट",
    hero_title_prefix: "ना अँकर, ना स्टुडिओ, ना एडिटर.",
    hero_title_suffix: "तुमचे न्यूज चॅनेल, पूर्णपणे AI द्वारे संचालित.",
    hero_extra: "ब्रेकिंग न्यूज २ तास नाही, तर फक्त २५ मिनिटांत मिळवा.",
    hero_tagline: "AI अँकरसह प्रोफेशनल न्यूज व्हिडिओ — तुमचा चेहरा, तुमचा आवाज, तुमचा ब्रँड.",
    hero_subtext: "पुढील पिढीच्या AI अँकरसह आपल्या डिजिटल न्यूज रूममध्ये क्रांती घडवा.",
    hero_hindi_detail: "स्टुडिओ, कॅमेरा किंवा मानवी अँकरशिवाय आजच आपले न्यूज चॅनेल सुरू करा.",
    hero_btn_samples: "नमुने पहा",
    hero_btn_pricing: "प्रायसिंग प्लॅन्स",
    hero_ticker: " • स्टुडिओची गरज नाही • १००+ भाषा उपलब्ध • ४K AI अँकर तयार • आजच तुमचे चॅनेल सुरू करा • कॅमेराची गरज नाही • ",
    about_badge: "आम्ही काय करतो",
    about_title: "अँकरशिवाय, स्टुडिओशिवाय, एडिटरशिवाय पूर्ण न्यूज चॅनेल चालवा.",
    about_title_accent: "बातम्यांपासून व्हिडिओपर्यंत फक्त २५ मिनिटे.",
    about_sublead: "स्टुडिओ नाही. अँकरचा पगार नाही. प्रोडक्शनचे कोणतेही टेन्शन नाही. यूट्यूब, फेसबुक आणि इतर प्लॅटफॉर्म्सवर प्रसिद्ध करण्यासाठी तयार.",
    about_vision_heading: "आम्ही फक्त व्हिडिओ बनवत नाही.",
    about_vision_span: "आम्ही पूर्णपणे ऑटोमेटेड डिजिटल न्यूज चॅनेल्स उभारतो.",
    about_desc1: "अनंता इन्फोटेक ही आर्टिफिशियल इंटेलिजन्स (AI) द्वारे संचालित न्यूज एडिटिंग एजन्सी आहे. आम्ही लहान आणि स्वतंत्र न्यूज चॅनेल्सना प्रोफेशनल दर्जाचे व्हिडिओ बनवण्यास मदत करतो — जलद, परवडणारे आणि पूर्ण प्रोडक्शन टीमशिवाय.",
    about_desc2: "तुम्हाला सामान्य AI अँकरसह दैनिक न्यूज व्हिडिओ हवा असो किंवा तुमच्यासारखाच दिसणारा आणि बोलणारा वैयक्तिकृत अँकर हवा असो, आम्ही एडिटिंगपासून डिलिव्हरीपर्यंत सर्व काही सायकलमध्ये सांभाळतो.",
    feat_ai_title: "अति-वास्तववादी AI अँकर",
    feat_ai_desc: "मानवासारखे हावभाव आणि अचूक लिप-सिंक असलेले अत्याधुनिक न्यूरल अवतार.",
    feat_prod_title: "दैनिक व्हिडिओ निर्मिती",
    feat_prod_desc: "ताज्या आणि संबंधित बातम्यांचे व्हिडिओ दररोज तुमच्या डॅशबोर्डवर पाठवले जातात.",
    feat_vis_title: "व्यावसायिक व्हिज्युअल्स",
    feat_vis_desc: "राष्ट्रीय टीव्ही चॅनेल्सना टक्कर देणारे व्हर्च्युअल स्टुडिओ आणि हाय-एंड न्यूज ग्राफिक्स.",
    feat_deliv_title: "जलद वितरण",
    feat_deliv_desc: "स्क्रिप्टपासून थेट ब्रॉडकास्ट-रेडी व्हिडिओ मिनिटांत, तासांत नाही.",
    feat_dep_title: "शून्य अवलंबित्व",
    feat_dep_desc: "अँकर किंवा एडिटरसाठी आता कोणतीही वाट पाहण्याची गरज नाही. तुमचे चॅनेल २४/७ ऑटोपायलटवर चालेल.",
    promo_badge: "तुमचे साम्राज्य सुरू करा",
    promo_text: "डिजिटल पत्रकारितेच्या भविष्यात पाऊल टाका.",
    promo_btn: "सुरू करा",
    how_title: "हे कसे काम करते",
    how_step1_title: "माहिती पाठवा",
    how_step1_desc: "आम्हाला तुमचे फुटेज, ऑडिओ आणि स्क्रिप्ट पाठवा.",
    how_step2_title: "AI प्रोसेसिंग",
    how_step2_desc: "आमची टीम आणि AI सिस्टीम तुमच्या कंटेंटवर प्रक्रिया आणि एडिट करते.",
    how_step3_title: "जलद डिलिव्हरी",
    how_step3_desc: "२५ मिनिटांत पब्लिश-रेडी न्यूज व्हिडिओ तुमच्या दारात.",
    why_title: "का",
    why_accent: "अनंता?",
    why_subtitle: "कारण तुमची स्पर्धा अजूनही हे मॅन्युअली करत आहे.",
    why_old_badge: "जुन्या अडचणी",
    why_old_heading: "मॅन्युअल निर्मिती",
    why_old_p1: "महागडे अँकर",
    why_old_p1_cost: "₹२५k–₹५०k/महिना",
    why_old_p2: "स्टुडिओ सेटअपचा मोठा खर्च",
    why_old_p3: "उत्पादन आणि एडिटिंगमध्ये विलंब",
    why_new_badge: "उत्तम किंमत",
    why_new_heading: "अनंता AI पॉवरहाऊस",
    why_new_p1_title: "कमी खर्च",
    why_new_p1_desc: "दैनिक बातम्यांचे व्हिडिओ मोठ्या पगाराच्या खर्चाशिवाय. प्लॅन्स फक्त ₹५,५००/महिना पासून सुरू.",
    why_new_p2_title: "सातत्यपूर्ण उत्पादन",
    why_new_p2_desc: "आता माणसांमुळे उशीर नाही. २४/७ विश्वसनीयता.",
    why_new_p3_title: "स्केलेबल उत्पादन",
    why_new_p3_desc: "१ ते १०० व्हिडिओंपर्यंत उत्पादन सहज वाढवा.",
    why_new_p4_title: "प्रो ब्रँडिंग",
    why_new_p4_desc: "पहिल्या सेकंदापासून राष्ट्रीय टीव्ही दर्जाचे व्हिज्युअल्स.",
    why_usp_point: "२ तासांऐवजी २५ मिनिटे — हाच आमचा फरक आहे. कोणत्याही स्टुडिओ सेटअपची गरज नाही. मानधनावरील पूर्णवेळ एडिटरची गरज नाही. तुमच्या चेहऱ्याचा आणि आवाजाचा AI अँकर — अत्यंत कमी किमतीत उपलब्ध.",
    pricing_title: "आमचे",
    pricing_title_accent: "प्रायसिंग प्लॅन्स",
    plan_standard_title: "Standard AI Anchor Plans",
    plan_standard_desc: "उच्च दर्जाच्या AI अँकरसह व्यावसायिक न्यूज व्हिडिओ. प्रोडक्शन टीमशिवाय आपले उत्पादन वाढवू इच्छिणाऱ्या चॅनेलसाठी योग्य.",
    plan_realface_title: "Real Face AI Anchor Plans",
    plan_realface_desc: "तुमचा चेहरा. तुमचा आवाज. AI अँकरमध्ये क्लोन — जो प्रत्येक व्हिडिओमध्ये तुमच्या चॅनेलची ओळख बनेल.",
    plan_starter_name: "Starter Plan",
    plan_starter_price: "₹५,५००",
    plan_starter_duration: "/ महिना",
    plan_starter_tagline: "स्थानिक आणि वाढत्या डिजिटल चॅनेल्ससाठी सर्वोत्तम",
    plan_starter_f1: "दररोज ३ व्हिडिओ, प्रत्येक ५ मिनिटांपर्यंत",
    plan_starter_f2: "व्यावसायिक AI अँकर",
    plan_starter_f3: "न्यूज व्हिज्युअल इंटीग्रेशन",
    plan_starter_f4: "कस्टम ब्रँडिंग आणि HD आउटपुट",
    plan_growth_name: "Growth Plan",
    plan_growth_price: "₹१०,०००",
    plan_growth_duration: "/ महिना",
    plan_growth_tagline: "दररोज एकापेक्षा जास्त अपडेट्स प्रसिद्ध करणाऱ्या चॅनेल्ससाठी",
    plan_growth_f1: "दररोज ६ व्हिडिओ, प्रत्येक ५ मिनिटांपर्यंत",
    plan_growth_f2: "प्रायोरिटी प्रोसेसिंग आणि जलद डिलिव्हरी",
    plan_growth_f3: "न्यूज व्हिज्युअल इंटीग्रेशन",
    plan_growth_f4: "कस्टम ब्रँडिंग आणि HD आउटपुट",
    plan_personal_name: "Personal AI Anchor",
    plan_personal_price: "₹७,५००",
    plan_personal_duration: "/ महिना",
    plan_personal_tagline: "तुमचा स्वतःचे चेहरा आणि आवाज व्यावसायिक AI अँकरमध्ये बदला",
    plan_personal_f1: "दररोज ३ व्हिडिओ, प्रत्येक ५ मिनिटांपर्यंत",
    plan_personal_f2: "तुमचा फेस क्लोन",
    plan_personal_f3: "तुमचा व्हॉईस क्लोन",
    plan_personal_f4: "कस्टम ब्रँडिंग आणि HD आउटपुट",
    plan_premium_personal_name: "Premium Personal AI Anchor",
    plan_premium_personal_price: "₹१३,०००",
    plan_premium_personal_duration: "/ महिना",
    plan_premium_personal_tagline: "वैयक्तिकृत AI ओळखीसह उच्च-प्रमाण उत्पादन",
    plan_premium_personal_f1: "दररोज ६ व्हिडिओ, प्रत्येक ५ मिनिटांपर्यंत",
    plan_premium_personal_f2: "तुमचा फेस आणि व्हॉईस क्लोन",
    plan_premium_personal_f3: "प्रायोरिटी प्रोसेसिंग आणि समर्पित सपोर्ट",
    plan_premium_personal_f4: "समर्पित सपोर्ट आणि HD आउटपुट",
    plan_custom_name: "कस्टम / एंटरप्राइज",
    plan_custom_desc: "अधिक व्हिडिओ हवे आहेत? मीडिया हाऊसेस, डिजिटल पब्लिशर्स, राजकीय संस्था आणि कंटेंट नेटवर्कसाठी सानुकूल एंटरप्राइज प्लॅन्स उपलब्ध आहेत.",
    plan_custom_btn: "संपर्क साधा",
    app_badge: "लवकरच येत आहे",
    app_title: "News Editor App",
    app_desc1: "तुमच्या कंटेंटवर पूर्ण नियंत्रण मिळवा. आमचे AI-संचालित ॲप न्यूज चॅनेलच्या मालकांना रेडीमेड टेम्पलेट्सचा वापर करून स्वतःचे व्हिडिओ तयार करण्याची आणि पब्लिश करण्याची परवानगी देते — कोणत्याही तांत्रिक कौशल्याची गरज नाही.",
    app_desc2: "तुमचा ऑडिओ, फुटेज, बी-रोल आणि हेडिंग्ज अपलोड करा. ॲप आपोआप पब्लिश-रेडी न्यूज व्हिडिओ जनरेट करतो.",
    app_price_tag: "फक्त ₹१,०००/महिना दराने लाँच होत आहे.",
    app_btn: "सूचना मिळवा",
    feedback_badge: "यशस्वी कथा",
    feedback_title: "विश्वास",
    feedback_title_accent: "डिजिटल न्यूजरूमचा",
    feedback_q1: "आम्ही प्रत्येक न्यूज व्हिडिओवर २ तासांपेक्षा जास्त वेळ घालवत होतो. आता ते २५ मिनिटांत होते — आणि ते पूर्वीपेक्षा अधिक व्यावसायिक दिसते.",
    feedback_a1_role: "न्यूज चॅनेल मालक, उत्तर प्रदेश",
    cta_title: "तुमचे न्यूज चॅनेल बदलण्यास तयार आहात का?",
    cta_subtitle: "तुमचा पहिला व्हिडिओ २५ मिनिटांत मिळवा.",
    cta_btn: "आजच संपर्क साधा — मर्यादित जागा उपलब्ध.",
    footer_tagline: "अनंता इन्फोटेक — AI-संचालित न्यूज, जलद डिलिव्हरी.",
    footer_desc: "अति-वास्तववादी AI अँकरसह पुढील पिढीच्या डिजिटल न्यूज रूमला सक्षम करणे.",
    footer_links: "जलद लिंक्स",
    footer_contact: "संपर्क",
    footer_rights: "© २०२६ अनंता इन्फोटेक. सर्व हक्क राखीव."
  },
  bn: {
    // Bangla (বাংলা)
    nav_tech: "প্রযুক্তি",
    nav_samples: "নমুনা",
    nav_pricing: "মূল্যতালিকা",
    nav_services: "সেবা",
    nav_demo_btn: "ফ্রি ডেমো",
    nav_chat_wa: "হোয়াটসঅ্যাপ চ্যাট",
    hero_title_prefix: "কোনো অ্যাঙ্কর নয়। কোনো স্টুডিও নয়। কোনো সম্পাদক নয়।",
    hero_title_suffix: "আপনার নিউজ চ্যানেল, সম্পূর্ণ এআই দ্বারা পরিচালিত।",
    hero_extra: "ব্রেকিং নিউজ ২ ঘণ্টায় নয়, মাত্র ২৫ মিনিটে ডেলিভারি।",
    hero_tagline: "এআই অ্যাঙ্করের সাথে পেশাদার নিউজ ভিডিও — আপনার মুখ, আপনার কণ্ঠস্বর, আপনার ব্র্যান্ড।",
    hero_subtext: "নেক্সট-জেনারেশন এআই অ্যাঙ্করের সাহায্যে আপনার ডিজিটাল নিউজরুমে বিপ্লব আনুন।",
    hero_hindi_detail: "স্টুডিও, ক্যামেরা বা হিউম্যান অ্যাঙ্কর ছাড়াই আজই আপনার নিউজ চ্যানেল শুরু করুন।",
    hero_btn_samples: "নমুনা দেখুন",
    hero_btn_pricing: "প্রাইসিং প্ল্যান",
    hero_ticker: " • কোনো স্টুডিও লাগবে না • ১০০+ ভাষা উপলব্ধ • ৪K এআই অ্যাঙ্কর তৈরি • আজই আপনার চ্যানেল শুরু করুন • কোনো ক্যামেরা লাগবে না • ",
    about_badge: "আমরা যা করি",
    about_title: "অ্যাঙ্কর ছাড়া, স্টুডিও ছাড়া, সম্পাদক ছাড়া সম্পূর্ণ নিউজ চ্যানেল চালান।",
    about_title_accent: "খবর থেকে ভিডিও মাত্র ২৫ মিনিটে।",
    about_sublead: "কোনো স্টুডিও নেই। কোনো অ্যাঙ্করের বেতন নেই। কোনো প্রোডাকশনের ঝামেলা নেই। ইউটিউব, ফেসবুক এবং অন্যান্য প্ল্যাটফর্মে প্রকাশের জন্য প্রস্তুত।",
    about_vision_heading: "আমরা শুধু ভিডিও তৈরি করি না।",
    about_vision_span: "আমরা সম্পূর্ণ স্বয়ংক্রিয় ডিজিটাল সংবাদ চ্যানেল তৈরি করি।",
    about_desc1: "অনন্ত ইনফোটেক হল একটি এআই-চালিত সংবাদ সম্পাদনা সংস্থা। আমরা ছোট এবং স্বাধীন নিউজ চ্যানেলগুলিকে ব্রডকাস্ট-কোয়ালিটির ভিডিও তৈরি করতে সাহায্য করি — দ্রুত, সাশ্রয়ী মূল্যে এবং কোনো প্রোডাকশন টিম ছাড়াই।",
    about_desc2: "আপনার সাধারণ এআই অ্যাঙ্করের সাথে দৈনিক খবরের ভিডিও প্রয়োজন হোক বা আপনার মতো দেখতে ও শুনতে একটি ব্যক্তিগতকৃত অ্যাঙ্কর প্রয়োজন হোক, আমরা সম্পাদনা থেকে ডেলিভারি পর্যন্ত সবকিছু সামলাই।",
    feat_ai_title: "অতি-বাস্তবসম্মত এআই অ্যাঙ্কর",
    feat_ai_desc: "মানুষের মতো অভিব্যক্তি এবং নিখুঁত লিপ-সিঙ্ক সহ অত্যাধুনিক নিউরাল অবতার।",
    feat_prod_title: "দৈনিক ভিডিও তৈরি",
    feat_prod_desc: "প্রতিদিন আপনার ড্যাশবোর্ডে তাজা এবং প্রাসঙ্গিক খবরের ভিডিও পৌঁছে দেওয়া হয়।",
    feat_vis_title: "পেশাদার ভিজ্যুয়াল",
    feat_vis_desc: "জাতীয় টিভি চ্যানেলগুলির সাথে প্রতিদ্বন্দ্বিতা করার মতো ভার্চুয়াল স্টুডিও এবং হাই-এন্ড নিউজ গ্রাফিক্স।",
    feat_deliv_title: "দ্রুত সরবরাহ",
    feat_deliv_desc: "স্ক্রিপ্ট থেকে সরাসরি ব্রডকাস্ট-রেডি ভিডিও মাত্র কয়েক মিনিটে, ঘণ্টার নয়।",
    feat_dep_title: "জিরো নির্ভরশীলতা",
    feat_dep_desc: "অ্যাঙ্কর বা সম্পাদকের জন্য আর অপেক্ষা করতে হবে না। আপনার চ্যানেল ২৪/৭ অটোপাইলটে চলবে।",
    promo_badge: "আপনার সাম্রাজ্য শুরু করুন",
    promo_text: "ডিজিটাল সাংবাদিকতার ভবিষ্যতে প্রবেশ করুন।",
    promo_btn: "শুরু করুন",
    how_title: "এটি কিভাবে কাজ করে",
    how_step1_title: "কন্টেন্ট পাঠান",
    how_step1_desc: "আমাদের কাছে আপনার ফুটেজ, অডিও এবং স্ক্রিপ্ট পাঠান।",
    how_step2_title: "এআই প্রসেসিং",
    how_step2_desc: "আমাদের টিম এবং এআই সিস্টেম আপনার কন্টেন্ট প্রসেস ও এডিট করবে।",
    how_step3_title: "দ্রুত ডেলিভারি",
    how_step3_desc: "২৫ মিনিটে আপনার প্রকাশ-প্রস্তুত খবরের ভিডিও পেয়ে যান।",
    why_title: "কেন",
    why_accent: "অনন্ত?",
    why_subtitle: "কারণ আপনার প্রতিযোগীরা এখনও এটি ম্যানুয়ালি করছে।",
    why_old_badge: "পুরনো সমস্যা",
    why_old_heading: "ম্যানুয়াল উৎপাদন",
    why_old_p1: "ব্যয়বহুল অ্যাঙ্কর",
    why_old_p1_cost: "₹২৫k–₹৫০k/মাস",
    why_old_p2: "উচ্চ স্টুডিও সেটআপ খরচ",
    why_old_p3: "বিলম্বিত উৎপাদন ও সম্পাদনা",
    why_new_badge: "সেরা মূল্য",
    why_new_heading: "অনন্ত এআই পাওয়ারহাউস",
    why_new_p1_title: "স্বল্প খরচ",
    why_new_p1_desc: "বিশাল বেতন খরচ ছাড়াই দৈনিক সংবাদ ভিডিও। প্ল্যান শুরু হচ্ছে মাত্র ₹৫,৫০০/মাস থেকে।",
    why_new_p2_title: "ধ্রুবক উৎপাদন",
    why_new_p2_desc: "আর মানুষের কারণে বিলম্ব নয়। ২৪/৭ নির্ভরযোগ্যতা।",
    why_new_p3_title: "স্কেলযোগ্য উৎপাদন",
    why_new_p3_desc: "১ থেকে ১০০টি ভিডিও পর্যন্ত সহজেই উৎপাদন বাড়ান।",
    why_new_p4_title: "প্রো ব্র্যান্ডিং",
    why_new_p4_desc: "প্রথম সেকেন্ড থেকেই জাতীয় টিভির মতো ভিজ্যুয়াল।",
    why_usp_point: "২ ঘণ্টা থেকে ২৫ মিনিট — এটাই আমাদের পার্থক্য। কোনো স্টুডিও সেটআপের প্রয়োজন নেই। বেতনে কোনো ফুল-টাইম সম্পাদক লাগবে না। আপনার নিজস্ব মুখ এবং কণ্ঠস্বর সহ এআই অ্যাঙ্কর — খুব কম খরচে উপলব্ধ।",
    pricing_title: "আমাদের",
    pricing_title_accent: "মূল্যতালিকা",
    plan_standard_title: "Standard AI Anchor Plans",
    plan_standard_desc: "উচ্চ মানের এআই অ্যাঙ্করের সাথে পেশাদার সংবাদ ভিডিও। প্রোডাকশন টিম নিয়োগ না করেই যাদের খবরের পরিমাণ বাড়াতে চান তাদের জন্য উপযুক্ত।",
    plan_realface_title: "Real Face AI Anchor Plans",
    plan_realface_desc: "আপনার মুখ। আপনার কণ্ঠস্বর। এআই অ্যাঙ্করে ক্লোন করা — যা প্রতিটি ভিডিওতে স্ক্রিনে আপনার চ্যানেলের পরিচয় ফুটিয়ে তুলবে।",
    plan_starter_name: "Starter Plan",
    plan_starter_price: "₹৫,৫০০",
    plan_starter_duration: "/ মাস",
    plan_starter_tagline: "স্থানীয় এবং ক্রমবর্ধমান ডিজিটাল চ্যানেলগুলির জন্য উপযুক্ত",
    plan_starter_f1: "প্রতিদিন ৩টি ভিডিও, প্রতিটি ৫ মিনিট পর্যন্ত",
    plan_starter_f2: "পেশাদার এআই অ্যাঙ্কর",
    plan_starter_f3: "নিউজ ভিজ্যুয়াল ইন্টিগ্রেশন",
    plan_starter_f4: "কাস্টম ব্র্যান্ডিং এবং এইচডি আউটপুট",
    plan_growth_name: "Growth Plan",
    plan_growth_price: "₹১০,০০০",
    plan_growth_duration: "/ মাস",
    plan_growth_tagline: "যারা প্রতিদিন একাধিক খবর প্রকাশ করেন তাদের জন্য উপযুক্ত",
    plan_growth_f1: "প্রতিদিন ৬টি ভিডিও, প্রতিটি ৫ মিনিট পর্যন্ত",
    plan_growth_f2: "অগ্রাধিকার প্রক্রিয়াকরণ এবং দ্রুত বিতরণ",
    plan_growth_f3: "নিউজ ভিজ্যুয়াল ইন্টিগ্রেশন",
    plan_growth_f4: "কাস্টম ব্র্যান্ডিং এবং এইচডি আউটপুট",
    plan_personal_name: "Personal AI Anchor",
    plan_personal_price: "₹৭,激活",
    plan_personal_duration: "/ মাস",
    plan_personal_tagline: "আপনার নিজের মুখ এবং কণ্ঠস্বরকে পেশাদার এআই উপস্থাপকের রূপ দিন",
    plan_personal_f1: "প্রতিদিন ৩টি ভিডিও, প্রতিটি ৫ মিনিট পর্যন্ত",
    plan_personal_f2: "আপনার ফেস ক্লোন",
    plan_personal_f3: "আপনার ভয়েস ক্লোন",
    plan_personal_f4: "কাস্টম ব্র্যান্ডিং এবং এইচডি আউটপুট",
    plan_premium_personal_name: "Premium Personal AI Anchor",
    plan_premium_personal_price: "₹১৩,০০০",
    plan_premium_personal_duration: "/ মাস",
    plan_premium_personal_tagline: "ব্যক্তিগতকৃত এআই পরিচয়ের সাথে উচ্চ-পরিমাণ উৎপাদন",
    plan_premium_personal_f1: "প্রতিদিন ৬টি ভিডিও, প্রতিটি ৫ মিনিট পর্যন্ত",
    plan_premium_personal_f2: "আপনার ফেস ক্লোন এবং ভয়েস ক্লোন",
    plan_premium_personal_f3: "অগ্রাধিকার প্রক্রিয়াকরণ এবং ডেডিকেটেড সাপোর্ট",
    plan_premium_personal_f4: "ডেডিকেটেড সাপোর্ট এবং এইচডি আউটপুট",
    plan_custom_name: "কাস্টম / এন্টারপ্রাইজ",
    plan_custom_desc: "আরও ভিডিও প্রয়োজন? মিডিয়া হাউস, ডিজিটাল পাবলিশার, রাজনৈতিক সংস্থা এবং কন্টেন্ট নেটওয়ার্কের জন্য কাস্টম এন্টারপ্রাইজ প্ল্যান উপলব্ধ।",
    plan_custom_btn: "যোগাযোগ করুন",
    app_badge: "শীঘ্রই আসছে",
    app_title: "News Editor App",
    app_desc1: "আপনার কন্টেন্টের সম্পূর্ণ নিয়ন্ত্রণ নিন। আমাদের এআই-চালিত অ্যাপ নিউজ চ্যানেলের মালিকদের রেডিমেড টেমপ্লেট ব্যবহার করে নিজস্ব ভিডিও তৈরি এবং প্রকাশ করতে দেয় — কোনো প্রযুক্তিগত দক্ষতার প্রয়োজন নেই।",
    app_desc2: "আপনার অডিও, ফুটেজ এবং শিরোনাম আপলোড করুন। অ্যাপটি স্বয়ংক্রিয়ভাবে একটি প্রকাশ-প্রস্তুত খবরের ভিডিও তৈরি করে।",
    app_price_tag: "মাত্র ₹১,০০০/মাসে লঞ্চ হচ্ছে।",
    app_btn: "নোটিফিকেশন পান",
    feedback_badge: "সফলতার গল্প",
    feedback_title: "বিশ্বাস",
    feedback_title_accent: "ডিজিটাল নিউজরুমের",
    feedback_q1: "আমরা প্রতিটি খবরের ভিডিওর জন্য ২ ঘণ্টার বেশি সময় ব্যয় করতাম। এখন এটি ২৫ মিনিটে সম্পন্ন হয় — এবং এটি আগের চেয়ে অনেক বেশি পেশাদার দেখায়।",
    feedback_a1_role: "নিউজ চ্যানেলের মালিক, উত্তর প্রদেশ",
    cta_title: "আপনার নিউজ চ্যানেল রূপান্তর করতে প্রস্তুত?",
    cta_subtitle: "২৫ মিনিটে আপনার প্রথম ভিডিও পান।",
    cta_btn: "আজই যোগাযোগ করুন — সীমিত স্লট উপলব্ধ।",
    footer_tagline: "অনন্ত ইনফোটেক — এআই-চালিত সংবাদ, দ্রুত সরবরাহ।",
    footer_desc: "অতি-বাস্তবসম্মত এআই অ্যাঙ্করের সাহায্যে নেক্সট-জেনারেশন ডিজিটাল নিউজরুমকে শক্তিশালী করা।",
    footer_links: "দ্রুত লিঙ্ক",
    footer_contact: "যোগাযোগ",
    footer_rights: "© ২০২৬ অনন্ত ইনফোটেক। সর্বস্বত্ব সংরক্ষিত।"
  },
  kn: {
    // Kannada (ಕನ್ನಡ)
    nav_tech: "ತಂತ್ರಜ್ಞಾನ",
    nav_samples: "ಮಾದರಿಗಳು",
    nav_pricing: "ದರಪಟ್ಟಿ",
    nav_services: "ಸೇವೆಗಳು",
    nav_demo_btn: "ಫ್ರೀ ಡೆಮೊ",
    nav_chat_wa: "ವಾಟ್ಸಾಪ್ ಚಾಟ್",
    hero_title_prefix: "ಆಂಕರ್ ಬೇಡ. ಸ್ಟುಡಿಯೋ ಬೇಡ. ಎಡಿಟರ್ ಬೇಡ.",
    hero_title_suffix: "ನಿಮ್ಮ ಸುದ್ದಿ ವಾಹಿನಿ, ಸಂಪೂರ್ಣವಾಗಿ AI ಮೂಲಕ ಚಾಲಿತ.",
    hero_extra: "ಬ್ರೇಕಿಂಗ್ ನ್ಯೂಸ್ ಕೇವಲ 25 ನಿಮಿಷಗಳಲ್ಲಿ — 2 ಗಂಟೆಗಳಲ್ಲ.",
    hero_tagline: "AI ಆಂಕರ್‌ನೊಂದಿಗೆ ವೃತ್ತಿಪರ ಸುದ್ದಿ ವೀಡಿಯೊಗಳು — ನಿಮ್ಮ ಮುಖ, ನಿಮ್ಮ ಧ್ವನಿ, ನಿಮ್ಮ ಬ್ರಾಂಡ್.",
    hero_subtext: "ಮುಂದಿನ ಪೀಳಿಗೆಯ AI ಆಂಕರ್‌ಗಳೊಂದಿಗೆ ನಿಮ್ಮ ಡಿಜಿಟಲ್ ಸುದ್ದಿ ಕೊಠಡಿಯನ್ನು ಕ್ರಾಂತಿಗೊಳಿಸಿ.",
    hero_hindi_detail: "ಸ್ಟುಡಿಯೋ, ಕ್ಯಾಮೆರಾ ಅಥವಾ ಮಾನವ ಆಂಕರ್ ಇಲ್ಲದೆ ಇಂದು ನಿಮ್ಮ ಸುದ್ದಿ ವಾಹಿನಿ ಪ್ರಾರಂಭಿಸಿ.",
    hero_btn_samples: "ಮಾದರಿಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    hero_btn_pricing: "ದರ ಯೋಜನೆಗಳು",
    hero_ticker: " • ಸ್ಟುಡಿಯೋ ಅಗತ್ಯವಿಲ್ಲ • 100+ ಭಾಷೆಗಳು ಲಭ್ಯ • 4K AI ಆಂಕರ್ ಸಿದ್ಧ • ಇಂದು ನಿಮ್ಮ ಚಾನಲ್ ಪ್ರಾರಂಭಿಸಿ • ಕ್ಯಾಮೆರಾ ಅಗತ್ಯವಿಲ್ಲ • ",
    about_badge: "ನಾವು ಏನು ಮಾಡುತ್ತೇವೆ",
    about_title: "ನಿಮ್ಮ ವಾಹಿನಿಯನ್ನು ಬದಲಾಯಿಸಿ",
    about_title_accent: "ಸುದ್ದಿಯಿಂದ ವೀಡಿಯೊಗೆ ಕೇವಲ 25 ನಿಮಿಷಗಳು.",
    about_sublead: "ಸ್ಟುಡಿಯೋ ಇಲ್ಲ. ಆಂಕರ್ ಸಂಬಳವಿಲ್ಲ. ಉತ್ಪಾದನೆಯ ತಲೆನೋವಿಲ್ಲ. ಯೂಟ್ಯೂಬ್, ಫೇಸ್‌ಬುಕ್ ಮತ್ತು ಇತರೆಡೆ ಪ್ರಕಟಿಸಲು ಸಿದ್ಧ.",
    about_vision_heading: "ನಾವು ಕೇವಲ ವೀಡಿಯೊಗಳನ್ನು ರಚಿಸುವುದಿಲ್ಲ.",
    about_vision_span: "ನಾವು ಸಂಪೂರ್ಣ ಸ್ವಯಂಚಾಲಿತ ಡಿಜಿಟಲ್ ಸುದ್ದಿ ವಾಹಿನಿಗಳನ್ನು ನಿರ್ಮಿಸುತ್ತೇವೆ.",
    about_desc1: "ಅನಂತ ಇನ್ಫೋಟೆಕ್ ಕೃತಕ ಬುದ್ಧಿಮತ್ತೆ (AI) ಚಾಲಿತ ಸುದ್ದಿ ಸಂಪಾದನೆ ಸಂಸ್ಥೆಯಾಗಿದೆ. ಸಣ್ಣ ಮತ್ತು ಸ್ವತಂತ್ರ ಸುದ್ದಿ ವಾಹಿನಿಗಳಿಗೆ ವೃತ್ತಿಪರ ಗುಣಮಟ್ಟದ ವೀಡಿಯೊ ವಿಷಯವನ್ನು ತಯಾರಿಸಲು ನಾವು ಸಹಾಯ ಮಾಡುತ್ತೇವೆ — ವೇಗವಾಗಿ, ಕೈಗೆಟುಕುವ ದರದಲ್ಲಿ ಮತ್ತು ಯಾವುದೇ ಪ್ರೊಡಕ್ಷನ್ ತಂಡವಿಲ್ಲದೆ.",
    about_desc2: "ಸಾಮಾನ್ಯ AI ಆಂಕರ್‌ನೊಂದಿಗೆ ನಿಮಗೆ ದೈನಂದಿನ ಸುದ್ದಿ ವೀಡಿಯೊ ಬೇಕಾಗಲಿ ಅಥವಾ ನಿಮ್ಮಂತೆಯೇ ಕಾಣುವ ಮತ್ತು ಧ್ವನಿಸುವ ವೈಯಕ್ತಿಕಗೊಳಿಸಿದ ಆಂಕರ್ ಬೇಕಾಗಲಿ, ಸಂಪಾದನೆಯಿಂದ ವಿತರಣೆಯವರೆಗೆ ಎಲ್ಲವನ್ನೂ ನಾವು ನಿರ್ವಹಿಸುತ್ತೇವೆ.",
    feat_ai_title: "ಅತ್ಯಂತ ನೈಜ AI ಆಂಕರ್‌ಗಳು",
    feat_ai_desc: "ಮಾನವ ತರಹದ ಅಭಿವ್ಯಕ್ತಿಗಳು ಮತ್ತು ಪರಿಪೂರ್ಣ ಲಿಪ್-ಸಿಂಕ್ ಹೊಂದಿರುವ ಅತ್ಯಾಧುನಿಕ ನ್ಯೂರಲ್ ಅವತಾರಗಳು.",
    feat_prod_title: "ದೈನಂದಿನ ವೀಡಿಯೊ ಉತ್ಪಾದನೆ",
    feat_prod_desc: "ಪ್ರತಿದಿನ ನಿಮ್ಮ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗೆ ತಾಜಾ ಮತ್ತು ಪ್ರಸ್ತುತ ಸುದ್ದಿ ವೀಡಿಯೊಗಳನ್ನು ತಲುಪಿಸಲಾಗುತ್ತದೆ.",
    feat_vis_title: "ವೃತ್ತಿಪರ ದೃಶ್ಯಗಳು",
    feat_vis_desc: "ರಾಷ್ಟ್ರೀಯ ಟಿವಿ ಚಾನೆಲ್‌ಗಳಿಗೆ ಪೈಪೋಟಿ ನೀಡುವ ವರ್ಚುವಲ್ ಸ್ಟುಡಿಯೋಗಳು ಮತ್ತು ಹೈ-ಎಂಡ್ ಸುದ್ದಿ ಗ್ರಾಫಿಕ್ಸ್.",
    feat_deliv_title: "ವೇಗದ ವಿತರಣೆ",
    feat_deliv_desc: "ಸ್ಕ್ರಿಪ್ಟ್‌ನಿಂದ ನೇರವಾಗಿ ಬ್ರಾಡ್‌ಕಾಸ್ಟ್-ರೆಡಿ ವೀಡಿಯೊ ಕೇವಲ ನಿಮಿಷಗಳಲ್ಲಿ, ಗಂಟೆಗಳಲ್ಲ.",
    feat_dep_title: "ಶೂನ್ಯ ಅವಲಂಬನೆ",
    feat_dep_desc: "ಆಂಕರ್ ಅಥವಾ ಎಡಿಟರ್‌ಗಾಗಿ ಇನ್ನು ಕಾಯಬೇಕಾಗಿಲ್ಲ. ನಿಮ್ಮ ಚಾನಲ್ 24/7 ಆಟೋಪೈಲಟ್‌ನಲ್ಲಿ ಚಲಿಸುತ್ತದೆ.",
    promo_badge: "ನಿಮ್ಮ ಸಾಮ್ರಾಜ್ಯವನ್ನು ಪ್ರಾರಂಭಿಸಿ",
    promo_text: "ಡಿಜಿಟಲ್ ಪತ್ರಿಕೋದ್ಯಮದ ಭವಿಷ್ಯಕ್ಕೆ ಹೆಜ್ಜೆ ಇರಿಸಿ.",
    promo_btn: "ಪ್ರಾರಂಭಿಸಿ",
    how_title: "ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
    how_step1_title: "ವಿಷಯ ಕಳುಹಿಸಿ",
    how_step1_desc: "ನಿಮ್ಮ ಫೂಟೇಜ್, ಆಡಿಯೋ ಮತ್ತು ಸ್ಕ್ರಿಪ್ಟ್ ಅನ್ನು ನಮಗೆ ಕಳುಹಿಸಿ.",
    how_step2_title: "AI ಸಂಸ್ಕರಣೆ",
    how_step2_desc: "ನಮ್ಮ ತಂಡ ಮತ್ತು AI ಸಿಸ್ಟಮ್ ನಿಮ್ಮ ವಿಷಯವನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸುತ್ತದೆ ಮತ್ತು ಸಂಪಾದಿಸುತ್ತದೆ.",
    how_step3_title: "ವೇಗದ ವಿತರಣೆ",
    how_step3_desc: "ನಿಮ್ಮ ಪ್ರಕಟಣೆಗೆ ಸಿದ್ಧವಾಗಿರುವ ಸುದ್ದಿ ವೀಡಿಯೊ 25 ನಿಮಿಷಗಳಲ್ಲಿ ತಲುಪುತ್ತದೆ.",
    why_title: "ಏಕೆ",
    why_accent: "ಅನಂತ?",
    why_subtitle: "ಏಕೆಂದರೆ ನಿಮ್ಮ ಪ್ರತಿಸ್ಪರ್ಧಿಗಳು ಇನ್ನೂ ಇದನ್ನು ಹಸ್ತಚಾಲಿತವಾಗಿ ಮಾಡುತ್ತಿದ್ದಾರೆ.",
    why_old_badge: "ಹಳೆಯ ಹೋರಾಟ",
    why_old_heading: "ಹಸ್ತಚಾಲಿತ ಉತ್ಪಾದನೆ",
    why_old_p1: "ದುಬಾರಿ ಆಂಕರ್‌ಗಳು",
    why_old_p1_cost: "₹25k–₹50k/ತಿಂಗಳು",
    why_old_p2: "ಹೆಚ್ಚಿನ ಸ್ಟುಡಿಯೋ ಸೆಟಪ್ ವೆಚ್ಚಗಳು",
    why_old_p3: "ವಿಳಂಬಿತ ಉತ್ಪಾದನೆ ಮತ್ತು ಸಂಪಾದನೆ",
    why_new_badge: "ಉತ್ತಮ ಮೌಲ್ಯ",
    why_new_heading: "ಅನಂತ AI ಪವರ್‌ಹೌಸ್",
    why_new_p1_title: "ಕಡಿಮೆ ವೆಚ್ಚ",
    why_new_p1_desc: "ಭಾರೀ ಸಂಬಳದ ವೆಚ್ಚವಿಲ್ಲದೆ ದೈನಂದಿನ ಸುದ್ದಿ ವೀಡಿಯೊಗಳು. ಯೋಜನೆಗಳು ಕೇವಲ ₹5,500/ತಿಂಗಳಿಗೆ ಪ್ರಾರಂಭವಾಗುತ್ತವೆ.",
    why_new_p2_title: "ಸ್ಥಿರ ಔಟ್‌ಪುಟ್",
    why_new_p2_desc: "ಇನ್ನು ಮಾನವ ವಿಳಂಬಗಳಿಲ್ಲ. 24/7 ವಿಶ್ವಾಸಾರ್ಹತೆ.",
    why_new_p3_title: "ಸ್ಕೇಲೆಬಲ್ ಉತ್ಪಾದನೆ",
    why_new_p3_desc: "1 ರಿಂದ 100 ವೀಡಿಯೊಗಳವರೆಗೆ ಉತ್ಪಾದನೆಯನ್ನು ಸುಲಭವಾಗಿ ಹೆಚ್ಚಿಸಿ.",
    why_new_p4_title: "ಪ್ರೊ ಬ್ರ್ಯಾಂಡಿಂಗ್",
    why_new_p4_desc: "ಮೊದಲ ಸೆಕೆಂಡ್‌ನಿಂದ ರಾಷ್ಟ್ರೀಯ ಟಿವಿ ಗುಣಮಟ್ಟದ ದೃಶ್ಯಗಳು.",
    why_usp_point: "2 ಗಂಟೆಗಳ ಬದಲು 25 ನಿಮಿಷಗಳು — ಇದೇ ನಮ್ಮ ವ್ಯತ್ಯಾಸ. ಯಾವುದೇ ಸ್ಟುಡಿಯೋ ಸೆಟಪ್ ಅಗತ್ಯವಿಲ್ಲ. ಪೂರ್ಣ ಸಮಯದ ಎಡಿಟರ್ ಅಗತ್ಯವಿಲ್ಲ. ನಿಮ್ಮದೇ ಮುಖ ಮತ್ತು ಧ್ವನಿಯೊಂದಿಗೆ AI ಆಂಕರ್ — ಅತ್ಯಂತ ಕಡಿಮೆ ವೆಚ್ಚದಲ್ಲಿ ಲಭ್ಯ.",
    pricing_title: "ನಮ್ಮ",
    pricing_title_accent: "ದರ ಯೋಜನೆಗಳು",
    plan_standard_title: "Standard AI Anchor Plans",
    plan_standard_desc: "ಉನ್ನತ ಗುಣಮಟ್ಟದ AI ಆಂಕರ್‌ನೊಂದಿಗೆ ವೃತ್ತಿಪರ ಸುದ್ದಿ ವೀಡಿಯೊಗಳು. ಪ್ರೊಡಕ್ಷನ್ ತಂಡವನ್ನು ನೇಮಿಸಿಕೊಳ್ಳದೆ ತಮ್ಮ ವಿಡಿಯೋಗಳನ್ನು ಹೆಚ್ಚಿಸಲು ಬಯಸುವ ವಾಹಿನಿಗಳಿಗೆ ಸೂಕ್ತವಾಗಿದೆ.",
    plan_realface_title: "Real Face AI Anchor Plans",
    plan_realface_desc: "ನಿಮ್ಮ ಮುಖ. ನಿಮ್ಮ ಧ್ವನಿ. AI ಆಂಕರ್‌ಗೆ ಕ್ಲೋನ್ ಮಾಡಲಾಗಿದೆ — ಪ್ರತಿ ವೀಡಿಯೊದಲ್ಲಿ ನಿಮ್ಮ ವಾಹಿನಿಯ ಗುರುತನ್ನು ಪರದೆಯ ಮೇಲೆ ಪ್ರತಿನಿಧಿಸುತ್ತದೆ.",
    plan_starter_name: "Starter Plan",
    plan_starter_price: "₹5,500",
    plan_starter_duration: "/ ತಿಂಗಳು",
    plan_starter_tagline: "ಸ್ಥಳೀಯ ಮತ್ತು ಬೆಳೆಯುತ್ತಿರುವ ಡಿಜಿಟಲ್ ವಾಹಿನಿಗಳಿಗೆ ಸೂಕ್ತವಾಗಿದೆ",
    plan_starter_f1: "ಪ್ರತಿದಿನ 3 ವೀಡಿಯೊಗಳು, ಪ್ರತಿಯೊಂದೂ 5 ನಿಮಿಷಗಳವರೆಗೆ",
    plan_starter_f2: "ವೃತ್ತಿಪರ AI ಆಂಕರ್",
    plan_starter_f3: "ಸುದ್ದಿ ದೃಶ್ಯಗಳ ಸಂಯೋಜನೆ",
    plan_starter_f4: "ಕಸ್ಟಮ್ ಬ್ರ್ಯಾಂಡಿಂಗ್ ಮತ್ತು HD ಔಟ್‌ಪುಟ್",
    plan_growth_name: "Growth Plan",
    plan_growth_price: "₹10,000",
    plan_growth_duration: "/ ತಿಂಗಳು",
    plan_growth_tagline: "ಪ್ರತಿದಿನ ಬಹು ನವೀಕರಣಗಳನ್ನು ಪ್ರಕಟಿಸುವ ವಾಹಿನಿಗಳಿಗಾಗಿ",
    plan_growth_f1: "ಪ್ರತಿದಿನ 6 ವೀಡಿಯೊಗಳು, ಪ್ರತಿಯೊಂದೂ 5 ನಿಮಿಷಗಳವರೆಗೆ",
    plan_growth_f2: "ಆದ್ಯತೆಯ ಸಂಸ್ಕರಣೆ ಮತ್ತು ವೇಗದ ವಿತರಣೆ",
    plan_growth_f3: "ಸುದ್ದಿ ದೃಶ್ಯಗಳ ಸಂಯೋಜನೆ",
    plan_growth_f4: "ಕಸ್ಟಮ್ ಬ್ರ್ಯಾಂಡಿಂಗ್ ಮತ್ತು HD ಔಟ್‌ಪುಟ್",
    plan_personal_name: "Personal AI Anchor",
    plan_personal_price: "₹7,500",
    plan_personal_duration: "/ ತಿಂಗಳು",
    plan_personal_tagline: "ನಿಮ್ಮ ಸ್ವಂತ ಮುಖ ಮತ್ತು ಧ್ವನಿಯನ್ನು ವೃತ್ತಿಪರ AI ಪ್ರೆಸೆಂಟರ್ ಆಗಿ ಪರಿವರ್ತಿಸಿ",
    plan_personal_f1: "ಪ್ರತಿದಿನ 3 ವೀಡಿಯೊಗಳು, ಪ್ರತಿಯೊಂದೂ 5 ನಿಮಿಷಗಳವರೆಗೆ",
    plan_personal_f2: "ನಿಮ್ಮ ಮುಖದ ಕ್ಲೋನ್",
    plan_personal_f3: "ನಿಮ್ಮ ಧ್ವನಿ ಕ್ಲೋನ್",
    plan_personal_f4: "ಕಸ್ಟಮ್ ಬ್ರ್ಯಾಂಡಿಂಗ್ ಮತ್ತು HD ಔಟ್‌ಪುಟ್",
    plan_premium_personal_name: "Premium Personal AI Anchor",
    plan_premium_personal_price: "₹13,000",
    plan_premium_personal_duration: "/ ತಿಂಗಳು",
    plan_premium_personal_tagline: "ವೈಯಕ್ತಿಕಗೊಳಿಸಿದ AI ಗುರುತಿನೊಂದಿಗೆ ಹೆಚ್ಚಿನ ಪ್ರಮಾಣದ ಉತ್ಪಾದನೆ",
    plan_premium_personal_f1: "ಪ್ರತಿದಿನ 6 ವೀಡಿಯೊಗಳು, ಪ್ರತಿಯೊಂದೂ 5 ನಿಮಿಷಗಳವರೆಗೆ",
    plan_premium_personal_f2: "ನಿಮ್ಮ ಮುಖದ ಕ್ಲೋನ್ ಮತ್ತು ಧ್ವನಿ ಕ್ಲೋನ್",
    plan_premium_personal_f3: "ಆದ್ಯತೆಯ ಸಂಸ್ಕರಣೆ ಮತ್ತು ವಿಶೇಷ ಬೆಂಬಲ",
    plan_premium_personal_f4: "ವಿಶೇಷ ಬೆಂಬಲ ಮತ್ತು HD ಔಟ್‌ಪುಟ್",
    plan_custom_name: "ಕಸ್ಟಮ್ / ಎಂಟರ್‌ಪ್ರೈಸ್",
    plan_custom_desc: "ಹೆಚ್ಚಿನ ವೀಡಿಯೊಗಳು ಬೇಕೇ? ಮಾಧ್ಯಮ ಸಂಸ್ಥೆಗಳು, ಡಿಜಿಟಲ್ ಪ್ರಕಾಶಕರು, ರಾಜಕೀಯ ಸಂಸ್ಥೆಗಳು ಮತ್ತು ವಿಷಯ ನೆಟ್‌ವರ್ಕ್‌ಗಳಿಗಾಗಿ ಕಸ್ಟಮ್ ಯೋಜನೆಗಳು ಲಭ್ಯವಿವೆ.",
    plan_custom_btn: "ಸಂಪರ್ಕಿಸಿ",
    app_badge: "ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ",
    app_title: "News Editor App",
    app_desc1: "ನಿಮ್ಮ ವಿಷಯದ ಮೇಲೆ ಸಂಪೂರ್ಣ ನಿಯಂತ್ರಣ ತೆಗೆದುಕೊಳ್ಳಿ. ನಮ್ಮ AI-ಚಾಲಿತ ಅಪ್ಲಿಕೇಶನ್ ಸುದ್ದಿ ವಾಹಿನಿ ಮಾಲೀಕರಿಗೆ ಸಿದ್ಧ ಟೆಂಪ್ಲೇಟ್‌ಗಳನ್ನು ಬಳಸಿಕೊಂಡು ತಮ್ಮದೇ ಆದ ವೀಡಿಯೊಗಳನ್ನು ರಚಿಸಲು ಮತ್ತು ಪ್ರಕಟಿಸಲು ಅನುಮતಿಸುತ್ತದೆ — ಯಾವುದೇ ತಾಂತ್ರಿಕ ಕೌಶಲ್ಯ ಅಗತ್ಯವಿಲ್ಲ.",
    app_desc2: "ನಿಮ್ಮ ಆಡಿಯೋ, ಫೂಟೇಜ್ ಮತ್ತು ಶೀರ್ಷಿಕೆಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ. ಅಪ್ಲಿಕೇಶನ್ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಪ್ರಕಟಣೆಗೆ ಸಿದ್ಧವಾಗಿರುವ ಸುದ್ದಿ ವೀಡಿಯೊವನ್ನು ರಚಿಸುತ್ತದೆ.",
    app_price_tag: "ಕೇವಲ ₹1,000/ತಿಂಗಳಿಗೆ ಪ್ರಾರಂಭವಾಗಲಿದೆ.",
    app_btn: "ಸೂಚನೆ ಪಡೆಯಿರಿ",
    feedback_badge: "ಯಶಸ್ಸಿನ ಕಥೆಗಳು",
    feedback_title: "ವಿಶ್ವಾಸ",
    feedback_title_accent: "ಡಿಜಿಟಲ್ ಸುದ್ದಿ ಕೊಠಡಿಗಳ",
    feedback_q1: "ನಾವು ಪ್ರತಿ ಸುದ್ದಿ ವೀಡಿಯೊಗೆ 2 ಗಂಟೆಗಳಿಗಿಂತ ಹೆಚ್ಚು ಸಮಯ ಕಳೆಯುತ್ತಿದ್ದೆವು. ಈಗ ಅದು 25 ನಿಮಿಷಗಳಲ್ಲಿ ಮುಗಿಯುತ್ತದೆ — ಮತ್ತು ಇದು ಮೊದಲಿಗಿಂತ ಹೆಚ್ಚು ವೃತ್ತಿಪರವಾಗಿ ಕಾಣುತ್ತದೆ.",
    feedback_a1_role: "ಸುದ್ದಿ ವಾಹಿನಿ ಮಾಲೀಕರು, ಉತ್ತರ ಪ್ರದೇಶ",
    cta_title: "ನಿಮ್ಮ ಸುದ್ದಿ ವಾಹಿನಿಯನ್ನು ಬದಲಾಯಿಸಲು ಸಿದ್ಧರಿದ್ದೀರಾ?",
    cta_subtitle: "ನಿಮ್ಮ ಮೊದಲ ವೀಡಿಯೊವನ್ನು 25 ನಿಮಿಷಗಳಲ್ಲಿ ಪಡೆಯಿರಿ.",
    cta_btn: "ಇಂದೇ ಸಂಪರ್ಕಿಸಿ — ಸೀಮಿತ ಅವಕಾಶಗಳು ಲಭ್ಯ.",
    footer_tagline: "ಅನಂತ ಇನ್ಫೋಟೆಕ್ — AI-ಚಾಲಿತ ಸುದ್ದಿ, ವೇಗದ ವಿತರಣೆ.",
    footer_desc: "ಅತ್ಯಂತ ನೈಜ AI ಆಂಕರ್‌ಗಳೊಂದಿಗೆ ಮುಂದಿನ ಪೀಳಿಗೆಯ ಡಿಜಿಟಲ್ ಸುದ್ದಿ ಕೊಠಡಿಯನ್ನು ಬಲಪಡಿಸುವುದು.",
    footer_links: "ತ್ವರಿತ ಲಿಂಕ್‌ಗಳು",
    footer_contact: "ಸಂಪರ್ક",
    footer_rights: "© 2026 ಅನಂತ ಇನ್ಫೋಟೆಕ್. ಎಲ್ಲ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದિರಿಸಲಾಗಿದೆ."
  },
  te: {
    // Telugu (తెలుగు)
    nav_tech: "సాంకేతికత",
    nav_samples: "నమూనాలు",
    nav_pricing: "ధరలు",
    nav_services: "సేవలు",
    nav_demo_btn: "ఉచిత డెమో",
    nav_chat_wa: "వాట్సాప్ చాట్",
    hero_title_prefix: "యాంకర్ లేదు. స్టూడియో లేదు. ఎడిటర్ లేదు.",
    hero_title_suffix: "మీ వార్తా ఛానల్, పూర్తిగా AI ద్వారా నడుస్తుంది.",
    hero_extra: "బ్రేకింగ్ న్యూస్ 2 గంటల్లో కాదు, కేవలం 25 నిమిషాల్లో.",
    hero_tagline: "AI యాంకర్‌తో ప్రొఫెషనల్ న్యూస్ వీడియోలు — మీ ముఖం, మీ వాయిస్, మీ బ్రాండ్.",
    hero_subtext: "నెక్స్ట్-జెనరేషన్ AI యాంకర్లతో మీ డిజిటల్ న్యూస్‌రూమ్‌లో విప్లవాన్ని తీసుకరాండి.",
    hero_hindi_detail: "స్టూడియో, కెమెరా లేదా హ్యూమన్ యాంకర్ లేకుండా ఈరోజే మీ వార్తా ఛానెల్ ప్రారంభించండి.",
    hero_btn_samples: "నమూనాలను చూడండి",
    hero_btn_pricing: "ధరల పట్టిక",
    hero_ticker: " • స్టూడియో అవసరం లేదు • 100+ భాషలు అందుబాటులో ఉన్నాయి • 4K AI యాంకర్ సిద్ధం • ఈరోజే మీ ఛానెల్ ప్రారంభించండి • కెమెరా అవసరం లేదు • ",
    about_badge: "మేము ఏమి చేస్తాము",
    about_title: "యాంకర్ లేకుండా, స్టూడియో లేకుండా, ఎడిటర్ లేకుండా పూర్తి వార్తా ఛానెల్‌ను నడపండి.",
    about_title_accent: "వార్తల నుండి వీడియో వరకు కేవలం 25 నిమిషాల్లో.",
    about_sublead: "స్టూడియో లేదు. యాంకర్ జీతం లేదు. ప్రొడక్షన్ తలనొప్పి లేదు. యూట్యూబ్, ఫేస్‌బుక్ మరియు ఇతర ప్లాట్‌ఫారమ్‌లలో ప్రచురించడానికి సిద్ధంగా ఉంది.",
    about_vision_heading: "మేము కేవలం వీడియోలను సృష్టించము.",
    about_vision_span: "మేము పూర్తిగా ఆటోమేటెడ్ డిజిటల్ వార్తా ఛానెల్‌లను నిర్మిస్తాము.",
    about_desc1: "అనంత ఇన్ఫోటెక్ అనేది ఆర్టిఫిషియల్ ఇంటెలిజెన్స్ (AI) ఆధారిత వార్తా సవరణ సంస్థ. చిన్న మరియు స్వతంత్ర వార్తా ఛానెల్‌లు ప్రొఫెషనల్ నాణ్యత గల వీడియో కంటెంట్‌ను సులభంగా, తక్కువ ఖర్చుతో మరియు ప్రొడక్షన్ టీమ్ లేకుండా రూపొందించడంలో మేము సహాయం చేస్తాము.",
    about_desc2: "మీకు సాధారణ AI యాంకర్‌తో రోజువారీ వార్తా వీడియో కావాలన్నా లేదా మీలాగే కనిపించే మరియు మాట్లాడే వ్యక్తిగతీకరించిన యాంకర్ కావాలన్నా, ఎడిటింగ్ నుండి డెలివరీ వరకు ప్రతిదీ మేము చూసుకుంటాము.",
    feat_ai_title: "అత్యంత సహజమైన AI యాంకర్లు",
    feat_ai_desc: "మానవుల వంటి హావభావాలు మరియు ఖచ్చితమైన లిప్-సింక్ ఉన్న అత్యాధునిక న్యూరల్ అవతారాలు.",
    feat_prod_title: "రోజువారీ వీడియో ప్రొడక్షన్",
    feat_prod_desc: "ప్రతిరోజూ మీ డాష్‌బోర్డ్‌కు తాజా మరియు సంబంధిత వార్తా వీడియోలు అందించబడతాయి.",
    feat_vis_title: "ప్రొఫెషనల్ విజువల్స్",
    feat_vis_desc: "జాతీయ టీవీ ఛానెల్‌లతో పోటీపడే వర్చువల్ స్టూడియోలు మరియు హై-ఎండ్ న్యూస్ గ్రాఫిక్స్.",
    feat_deliv_title: "వేగవంతమైన డెలివరీ",
    feat_deliv_desc: "స్క్రిప్ట్ నుండి నేరుగా బ్రాడ్‌కాస్ట్-రెడీ వీడియో కేవలం నిమిషాల్లో, గంటల్లో కాదు.",
    feat_dep_title: "శూన్య ఆధారపడటం",
    feat_dep_desc: "యాంకర్ లేదా ఎడిటర్ కోసం ఇక వేచి ఉండాల్సిన అవసరం లేదు. మీ ఛానెల్ 24/7 ఆటోపైలట్‌లో నడుస్తుంది.",
    promo_badge: "మీ సామ్రాజ్యాన్ని ప్రారంభించండి",
    promo_text: "డిజిటల్ జర్నలిజం భవిష్యత్తులోకి అడుగు పెట్టండి.",
    promo_btn: "ప్రారంభించండి",
    how_title: "ఇది ఎలా పనిచేస్తుంది",
    how_step1_title: "కంటెంట్ పంపండి",
    how_step1_desc: "మీ ఫుటేజ్, ఆడియో మరియు స్క్రిప్ట్ మాకు పంపండి.",
    how_step2_title: "AI ప్రాసెసింగ్",
    how_step2_desc: "మా బృందం మరియు AI సిస్టమ్ మీ కంటెంట్‌ను ప్రాసెస్ మరియు ఎడిట్ చేస్తుంది.",
    how_step3_title: "వేగవంతమైన డెలివరీ",
    how_step3_desc: "25 నిమిషాల్లో పబ్లిష్-రెడీ వార్తా వీడియో మీ వద్ద ఉంటుంది.",
    why_title: "ఎందుకు",
    why_accent: "అనంత?",
    why_subtitle: "ఎందుకంటే మీ పోటీదారులు ఇంకా దీనిని మాన్యువల్‌గా చేస్తున్నారు.",
    why_old_badge: "పాత కష్టాలు",
    why_old_heading: "మాన్యువల్ ప్రొడక్షన్",
    why_old_p1: "ఖరీదైన యాంకర్లు",
    why_old_p1_cost: "₹25k–₹50k/నెలకు",
    why_old_p2: "అధిక స్టూడియో సెటప్ ఖర్చులు",
    why_old_p3: "ఆలస్యమైన ప్రొడక్షన్ & ఎడిటింగ్",
    why_new_badge: "ఉత్తమ విలువ",
    why_new_heading: "అనంత AI పవర్‌హౌస్",
    why_new_p1_title: "తక్కువ ఖర్చు",
    why_new_p1_desc: "భారీ జీతాల ఖర్చులు లేకుండా రోజువారీ వార్తా వీడియోలు. ప్లాన్లు కేవలం ₹5,500/నెలకు ప్రారంభమవుతాయి.",
    why_new_p2_title: "నిరంతర ఉత్పత్తి",
    why_new_p2_desc: "ఇక మానవ ఆలస్యాలు లేవు. 24/7 నమ్మకశక్యత.",
    why_new_p3_title: "స్కేలబుల్ ప్రొడక్షన్",
    why_new_p3_desc: "1 నుండి 100 వీడియోల వరకు సులభంగా ప్రొడక్షన్ పెంచుకోండి.",
    why_new_p4_title: "ప్రో బ్రాండింగ్",
    why_new_p4_desc: "మొదటి సెకను నుండి జాతీయ టీవీ స్థాయి విజువల్స్.",
    why_usp_point: "2 గంటల నుండి 25 నిమిషాలు — ఇదే మా వ్యత్యాసం. స్టూడియో సెటప్ అవసరం లేదు. ఫుల్-టైమ్ ఎడిటర్ అవసరం లేదు. మీ స్వంత ముఖం మరియు వాయిస్‌తో AI యాంకర్ — తక్కువ ఖర్చుతో లభ్యం.",
    pricing_title: "మా",
    pricing_title_accent: "ధరల ప్రణాళికలు",
    plan_standard_title: "Standard AI Anchor Plans",
    plan_standard_desc: "అధిక నాణ్యత గల AI యాంకర్‌తో ప్రొఫెషనల్ వార్తా వీడియోలు. ప్రొడక్షన్ టీమ్ లేకుండా తమ అవుట్‌పుట్ను పెంచాలనుకునే ఛానెల్‌ల కోసం.",
    plan_realface_title: "Real Face AI Anchor Plans",
    plan_realface_desc: "మీ ముఖం. మీ వాయిస్. AI యాంకర్‌గా క్లోన్ చేయబడింది — ఇది ప్రతి వీడియోలో మీ ఛానెల్ గుర్తింపును స్క్రీన్‌పై ప్రతిబింబిస్తుంది.",
    plan_starter_name: "Starter Plan",
    plan_starter_price: "₹5,500",
    plan_starter_duration: "/ నెలకు",
    plan_starter_tagline: "స్థానిక మరియు ఎదుగుతున్న డిజిటల్ ఛానెల్‌ల కోసం అనువైనది",
    plan_starter_f1: "రోజుకు 3 వీడియోలు, ఒక్కొక్కటి 5 నిమిషాల వరకు",
    plan_starter_f2: "ప్రొఫెషనల్ AI యాంకర్",
    plan_starter_f3: "వార్తా విజువల్స్ అనుసంధానం",
    plan_starter_f4: "కస్టమ్ బ్రాండింగ్ & HD అవుట్‌పుట్",
    plan_growth_name: "Growth Plan",
    plan_growth_price: "₹10,000",
    plan_growth_duration: "/ నెలకు",
    plan_growth_tagline: "ప్రతిరోజూ బహుళ నవీకరణలను ప్రచురించే ఛానెల్‌ల కోసం",
    plan_growth_f1: "రోజుకు 6 వీడియోలు, ఒక్కొక్కటి 5 నిమిషాల వరకు",
    plan_growth_f2: "ప్రాధాన్యత ప్రాసెసింగ్ & వేగవంతమైన డెలివరీ",
    plan_growth_f3: "వార్తా విజువల్స్ అనుసంధానం",
    plan_growth_f4: "కస్టమ్ బ్రాండింగ్ & HD అవుట్‌పుట్",
    plan_personal_name: "Personal AI Anchor",
    plan_personal_price: "₹7,500",
    plan_personal_duration: "/ నెలకు",
    plan_personal_tagline: "మీ స్వంత ముఖం మరియు వాయిస్‌ని ప్రొఫెషనల్ AI ప్రజెంటర్‌గా మార్చండి",
    plan_personal_f1: "రోజుకు 3 వీడియోలు, ఒక్కొక్కటి 5 నిమిషాల వరకు",
    plan_personal_f2: "మీ ఫేస్ క్లోన్",
    plan_personal_f3: "మీ వాయిస్ క్లోన్",
    plan_personal_f4: "కస్టమ్ బ్రాండింగ్ & HD అవుట్‌పుట్",
    plan_premium_personal_name: "Premium Personal AI Anchor",
    plan_premium_personal_price: "₹13,000",
    plan_premium_personal_duration: "/ నెలకు",
    plan_premium_personal_tagline: "వ్యక్తిగతీకరించిన AI గుర్తింపుతో అధిక-పరిమాణ ఉత్పత్తి",
    plan_premium_personal_f1: "రోజుకు 6 వీడియోలు, ఒక్కొక్కటి 5 నిమిషాల వరకు",
    plan_premium_personal_f2: "మీ ఫేస్ క్లోన్ & వాయిస్ క్లోన్",
    plan_premium_personal_f3: "ప్రాధాన్యత ప్రాసెసింగ్ & ప్రత్యేక మద్దతు",
    plan_premium_personal_f4: "ప్రత్యేక మద్దతు & HD అవుట్‌పుట్",
    plan_custom_name: "కస్టమ్ / ఎంటర్‌ప్రైజ్",
    plan_custom_desc: "మరిన్ని వీడియోలు కావాలా? మీడియా హౌస్‌లు, డిజిటల్ పబ్లిషర్లు, రాజకీయ సంస్థలు మరియు కంటెంట్ నెట్‌వర్క్‌ల కోసం కస్టమ్ ఎంటర్‌ప్రైజ్ ప్లాన్‌లు అందుబాటులో ఉన్నాయి.",
    plan_custom_btn: "సంప్రదించండి",
    app_badge: "త్వరలోనే వస్తోంది",
    app_title: "News Editor App",
    app_desc1: "మీ కంటెంట్‌పై పూర్తి నియంత్రణ తీసుకోండి. మా AI-ఆధారిత యాప్ వార్తా ఛానల్ యజమానులకు సిద్ధంగా ఉన్న టెంప్લેట్‌లను ఉపయోగించి వారి స్వంత వీడియోలను రూపొందించడానికి మరియు ప్రచురించడానికి అనుమతిస్తుంది — సాంకేతిక నైపుణ్యాలు అవసరం లేదు.",
    app_desc2: "మీ ఆడియో, ఫుటేజ్ మరియు శీర్షికలను అప్‌లోడ్ చేయండి. యాప్ స్వయంచాలకంగా ప్రచురించడానికి సిద్ధంగా ఉన్న వార్తా వీడియోను సృష్టిస్తుంది.",
    app_price_tag: "కేవలం ₹1,000/నెలకు ప్రారంభించబడుతుంది.",
    app_btn: "సమాచారం పొందండి",
    feedback_badge: "విజయ గాథలు",
    feedback_title: "నమ్మకం",
    feedback_title_accent: "డిజిటల్ న్యూస్‌రూమ్‌ల",
    feedback_q1: "మేము ప్రతి వార్తా వీడియోపై 2 గంటల కంటే ఎక్కువ సమయం గడిపేవాళ్ళం. ఇప్పుడు అది 25 నిమిషాల్లో పూర్తవుతుంది — మరియు ఇది మునుపటి కంటే చాలా ప్రొఫెషనల్‌గా కనిపిస్తుంది.",
    feedback_a1_role: "న్యూస్ ఛానల్ యజమాని, ఉత్తర ప్రదేశ్",
    cta_title: "మీ వార్తా ఛానెల్‌ను మార్చడానికి సిద్ధంగా ఉన్నారా?",
    cta_subtitle: "మీ మొదటి వీడియోను 25 నిమిషాల్లో పొందండి.",
    cta_btn: "ఈరోజే సంప్రదించండి — పరిమిత స్లాట్లు మాత్రమే అందుబాటులో ఉన్నాయి.",
    footer_tagline: "అనంత ఇన్ఫోటెక్ — AI ఆధారిత వార్తలు, వేగవంతమైన డెలివరీ.",
    footer_desc: "అత్యంత సహజమైన AI యాంకర్లతో తదుపరి తరం డిజిటల్ న్యూస్‌రూమ్‌ను శక్తివంతం చేయడం.",
    footer_links: "శీఘ్ర లింకులు",
    footer_contact: "సంప్రదించండి",
    footer_rights: "© 2026 అనంత ఇన్ఫోటెక్. అన్ని హక్కులు ప్రత్యేకించబడ్డాయి."
  },
  ta: {
    // Tamil (தமிழ்)
    nav_tech: "தொழில்நுட்பம்",
    nav_samples: "மாதிரிகள்",
    nav_pricing: "கட்டணங்கள்",
    nav_services: "சேவைகள்",
    nav_demo_btn: "இலவச டெமோ",
    nav_chat_wa: "வாட்ஸ்அப் அரட்டை",
    hero_title_prefix: "ஆங்கர் இல்லை. ஸ்டுடியோ இல்லை. எடிட்டர் இல்லை.",
    hero_title_suffix: "உங்கள் செய்தி சேனல், முற்றிலும் AI மூலம் இயங்குகிறது.",
    hero_extra: "பிரேக்கிங் நியூஸ் 2 மணிநேரத்தில் இல்லை, வெறும் 25 நிமிடங்களில்.",
    hero_tagline: "AI ஆங்கருடன் கூடிய தொழில்முறை செய்தி வீடியோக்கள் — உங்கள் முகம், உங்கள் குரல், உங்கள் பிராண்ட்.",
    hero_subtext: "அடுத்த தலைமுறை AI செய்தி தொகுப்பாளர்களுடன் உங்கள் டிஜிட்டல் செய்தி அறையை புரட்சிகரமாக்குங்கள்.",
    hero_hindi_detail: "ஸ்டுடியோ, கேமரா அல்லது மனித தொகுப்பாளர் இல்லாமல் இன்று உங்கள் செய்தி சேனலைத் தொடங்குங்கள்.",
    hero_btn_samples: "மாதிரிகளைப் பார்க்கவும்",
    hero_btn_pricing: "கட்டண விவரங்கள்",
    hero_ticker: " • ஸ்டுடியோ தேவையில்லை • 100+ மொழிகள் கிடைக்கும் • 4K AI செய்தி ஆங்கர் தயார் • இன்று உங்கள் சேனலைத் தொடங்குங்கள் • கேமரா தேவையில்லை • ",
    about_badge: "நாம் என்ன செய்கிறோம்",
    about_title: "தொகுப்பாளர் இல்லாமல், ஸ்டுடியோ இல்லாமல், எடிட்டர் இல்லாமல் முழு செய்தி சேனலையும் நடத்துங்கள்.",
    about_title_accent: "செய்தியிலிருந்து வீடியோ வரை வெறும் 25 நிமிடங்களில்.",
    about_sublead: "ஸ்டுடியோ இல்லை. ஆங்கர் சம்பளம் இல்லை. தயாரிப்பு தலைவலி இல்லை. யூடியூப், முகநூல் மற்றும் பிற தளங்களில் வெளியிட தயாராக உள்ளது.",
    about_vision_heading: "நாங்கள் வீடியோக்களை மட்டும் உருவாக்கவில்லை.",
    about_vision_span: "நாங்கள் முழுமையாக தானியங்கி டிஜிட்டல் செய்தி சேனல்களை உருவாக்குகிறோம்.",
    about_desc1: "அனந்தா இன்போடெக் என்பது செயற்கை நுண்ணறிவு (AI) மூலம் இயங்கும் செய்தி எடிட்டிங் நிறுவனமாகும். சிறிய மற்றும் சுயாதீன செய்தி சேனல்கள் தொழில்முறை தரமான வீடியோக்களை விரைவாகவும், குறைந்த செலவிலும், தயாரிப்புக் குழு இல்லாமலும் உருவாக்க நாங்கள் உதவுகிறோம்.",
    about_desc2: "உங்களுக்கு பொதுவான AI ஆங்கருடன் தினசரி செய்தி வீடியோ தேவைப்பட்டாலும் அல்லது உங்களைப் போலவே தோற்றமளிக்கும் மற்றும் பேசும் தனிப்பயனாக்கப்பட்ட ஆங்கர் தேவைப்பட்டாலும், எடிட்டிங் முதல் டெலிவரி வரை அனைத்தையும் நாங்கள் கையாளுகிறோம்.",
    feat_ai_title: "மிகவும் யதார்த்தமான AI செய்தி தொகுப்பாளர்கள்",
    feat_ai_desc: "மனிதனைப் போன்ற வெளிப்பாடுகள் மற்றும் சரியான உதடு ஒத்திசைவு கொண்ட அதிநவீன நரம்பியல் அவதாரங்கள்.",
    feat_prod_title: "தினசரி வீடியோ தயாரிப்பு",
    feat_prod_desc: "ஒவ்வொரு நாளும் புதிய மற்றும் பொருத்தமான செய்தி வீடியோக்கள் உங்கள் டாஷ்போர்டுக்கு வழங்கப்படுகின்றன.",
    feat_vis_title: "தொழில்முறை காட்சிகள்",
    feat_vis_desc: "தேசிய செய்தி சேனல்களுக்கு சவால் விடும் மெய்நிகர் ஸ்டுடியோக்கள் மற்றும் உயர்தர செய்தி கிராபிக்ஸ்.",
    feat_deliv_title: "விரைவான விநியோகம்",
    feat_deliv_desc: "ஸ்கிரிப்ட்டில் இருந்து நேரடியாக ஒளிபரப்பிற்கு தயாரான வீடியோ நிமிடங்களில், மணிநேரங்களில் அல்ல.",
    feat_dep_title: "பூஜ்ஜிய சார்பு",
    feat_dep_desc: "ஆங்கர் அல்லது எடிட்டருக்காக இனி காத்திருக்க வேண்டியதில்லை. உங்கள் சேனல் 24/7 ஆட்டோபைலட்டில் இயங்கும்.",
    promo_badge: "உங்கள் சாம்ராஜ்யத்தைத் தொடங்குங்கள்",
    promo_text: "டிஜிட்டல் இதழியல் எதிர்காலத்தில் காலடி எடுத்து வையுங்கள்.",
    promo_btn: "தொடங்கவும்",
    how_title: "இது எப்படி வேலை செய்கிறது",
    how_step1_title: "உள்ளடக்கம் அனுப்பவும்",
    how_step1_desc: "உங்கள் காட்சிகளை, ஆடியோவை மற்றும் ஸ்கிரிப்டை எங்களுக்கு அனுப்பவும்.",
    how_step2_title: "AI செயலாக்கம்",
    how_step2_desc: "எங்கள் குழு மற்றும் AI அமைப்பு உங்கள் உள்ளடக்கத்தை செயலாக்கி எடிட் செய்கிறது.",
    how_step3_title: "விரைவான டெலிவரி",
    how_step3_desc: "25 நிமிடங்களில் வெளியிடத் தயாரான செய்தி வீடியோ உங்களிடம் இருக்கும்.",
    why_title: "ஏன்",
    why_accent: "அனந்தா?",
    why_subtitle: "ஏனெனில் உங்கள் போட்டியாளர்கள் இன்னும் இதை கைமுறையாகச் செய்கிறார்கள்.",
    why_old_badge: "பழைய போராட்டம்",
    why_old_heading: "கைமுறை தயாரிப்பு",
    why_old_p1: "விலையுயர்ந்த செய்தி தொகுப்பாளர்கள்",
    why_old_p1_cost: "₹25k–₹50k/மாதம்",
    why_old_p2: "அதிக ஸ்டுジオ அமைப்பு செலவுகள்",
    why_old_p3: "தாமதமான தயாரிப்பு மற்றும் எடிட்டிங்",
    why_new_badge: "சிறந்த மதிப்பு",
    why_new_heading: "அனந்தா AI பவர்ஹவுஸ்",
    why_new_p1_title: "குறைந்த செலவு",
    why_new_p1_desc: "அதிக சம்பள செலவுகள் இல்லாமல் தினசரி செய்தி வீடியோக்கள். கட்டணங்கள் வெறும் ₹5,500/மாதத்தில் இருந்து தொடங்குகின்றன.",
    why_new_p2_title: "நிலையான வெளியீடு",
    why_new_p2_desc: "மனித தாமதங்கள் இனி இல்லை. 24/7 நம்பகத்தன்மை.",
    why_new_p3_title: "அளவிடக்கூடிய தயாரிப்பு",
    why_new_p3_desc: "1 முதல் 100 வீடியோக்கள் வரை தயாரிப்பை எளிதாக அதிகரிக்கவும்.",
    why_new_p4_title: "சார்பு பிராண்டிங்",
    why_new_p4_desc: "முதல் நொடியில் இருந்தே தேசிய தொலைக்காட்சி தரத்திலான காட்சிகள்.",
    why_usp_point: "2 மணிநேரத்திற்கு பதிலாக 25 நிமிடங்கள் — இதுவே எங்கள் வித்தியாசம். ஸ்டுடியோ அமைப்பு தேவையில்லை. முழு நேர எடிட்டர் தேவையில்லை. உங்கள் சொந்த முகம் மற்றும் குரலுடன் AI ஆங்கர் — குறைந்த செலவில் கிடைக்கும்.",
    pricing_title: "எங்கள்",
    pricing_title_accent: "கட்டண திட்டங்கள்",
    plan_standard_title: "Standard AI Anchor Plans",
    plan_standard_desc: "உயர்தர AI ஆங்கருடன் தொழில்முறை செய்தி வீடியோக்கள். தயாரிப்புக் குழுவை வேலைக்கு அமர்த்தாமல் தங்கள் வெளியீட்டை அதிகரிக்க விரும்பும் சேனல்களுக்கு ஏற்றது.",
    plan_realface_title: "Real Face AI Anchor Plans",
    plan_realface_desc: "உங்கள் முகம். உங்கள் குரல். AI ஆங்கராக குளோன் செய்யப்பட்டது — இது ஒவ்வொரு வீடியோவிலும் உங்கள் சேனலின் அடையாளத்தை திரையில் பிரதிபலிக்கும்.",
    plan_starter_name: "Starter Plan",
    plan_starter_price: "₹5,500",
    plan_starter_duration: "/ மாதம்",
    plan_starter_tagline: "உள்ளூர் மற்றும் வளரும் டிஜிட்டல் சேனல்களுக்கு ஏற்றது",
    plan_starter_f1: "தினமும் 3 வீடியோக்கள், ஒவ்வொன்றும் 5 நிமிடங்கள் வரை",
    plan_starter_f2: "தொழில்முறை AI செய்தி ஆங்கர்",
    plan_starter_f3: "செய்தி காட்சிகள் ஒருங்கிணைப்பு",
    plan_starter_f4: "தனிப்பயன் பிராண்டிங் & HD வெளியீடு",
    plan_growth_name: "Growth Plan",
    plan_growth_price: "₹10,000",
    plan_growth_duration: "/ மாதம்",
    plan_growth_tagline: "தினமும் பல புதுப்பிப்புகளை வெளியிடும் சேனல்களுக்காக",
    plan_growth_f1: "தினமும் 6 வீடியோக்கள், ஒவ்வொன்றும் 5 நிமிடங்கள் வரை",
    plan_growth_f2: "முன்னுரிமை செயலாக்கம் & விரைவான விநியோகம்",
    plan_growth_f3: "செய்தி காட்சிகள் ஒருங்கிணைப்பு",
    plan_growth_f4: "தனிப்பயன் பிராண்டிங் & HD வெளியீடு",
    plan_personal_name: "Personal AI Anchor",
    plan_personal_price: "₹7,500",
    plan_personal_duration: "/ மாதம்",
    plan_personal_tagline: "உங்கள் சொந்த முகம் மற்றும் குரலை தொழில்முறை AI தொகுப்பாளராக மாற்றவும்",
    plan_personal_f1: "தினமும் 3 வீடியோக்கள், ஒவ்வொன்றும் 5 நிமிடங்கள் வரை",
    plan_personal_f2: "உங்கள் முகம் குளோன்",
    plan_personal_f3: "உங்கள் குரல் குளோன்",
    plan_personal_f4: "தனிப்பயன் பிராண்டிங் & HD வெளியீடு",
    plan_premium_personal_name: "Premium Personal AI Anchor",
    plan_premium_personal_price: "₹13,000",
    plan_premium_personal_duration: "/ மாதம்",
    plan_premium_personal_tagline: "தனிப்பயனாக்கப்பட்ட AI அடையாளத்துடன் அதிக அளவு தயாரிப்பு",
    plan_premium_personal_f1: "தினமும் 6 வீடியோக்கள், ஒவ்வொன்றும் 5 நிமிடங்கள் வரை",
    plan_premium_personal_f2: "உங்கள் முகம் குளோன் & குரல் குளோன்",
    plan_premium_personal_f3: "முன்னுரிமை செயலாக்கம் & பிரத்யேக ஆதரவு",
    plan_premium_personal_f4: "பிரத்யேக ஆதரவு & HD வெளியீடு",
    plan_custom_name: "தனிப்பயன் / எண்டர்பிரைஸ்",
    plan_custom_desc: "கூடுதல் வீடியோக்கள் தேவையா? ஊடக நிறுவனங்கள், டிஜிட்டல் வெளியீட்டாளர்கள், அரசியல் அமைப்புகள் மற்றும் உள்ளடக்க நெட்வொர்க்குகளுக்கு தனிப்பயன் திட்டங்கள் கிடைக்கின்றன.",
    plan_custom_btn: "தொடர்பு கொள்ளவும்",
    app_badge: "விரைவில் வருகிறது",
    app_title: "News Editor App",
    app_desc1: "உங்கள் உள்ளடக்கத்தின் மீது முழு கட்டுப்பாட்டைப் பெறுங்கள். எங்கள் AI-இயங்கும் பயன்பாடு செய்தி சேனல் உரிமையாளர்களுக்கு ஆயத்த வார்ப்புருக்களைப் பயன்படுத்தி தங்கள் சொந்த வீடியோக்களை உருவாக்க மற்றும் வெளியிட அனுமதிக்கிறது — தொழில்நுட்ப திறன்கள் தேவையில்லை.",
    app_desc2: "உங்கள் ஆடியோ, காட்சிகள் மற்றும் தலைப்புகளைப் பதிவேற்றவும். பயன்பாடு தானாகவே வெளியிடத் தயாரான செய்தி வீடியோவை உருவாக்குகிறது.",
    app_price_tag: "வெறும் ₹1,000/மாதத்தில் தொடங்கப்படும்.",
    app_btn: "அறிவிப்பைப் பெறுக",
    feedback_badge: "வெற்றி கதைகள்",
    feedback_title: "நம்பிக்கை",
    feedback_title_accent: "டிஜிட்டல் செய்தி அறைகளின்",
    feedback_q1: "நாங்கள் ஒவ்வொரு செய்தி வீடியோவிற்கும் 2 மணி நேரத்திற்கும் மேலாக செலவிட்டோம். இப்போது அது 25 நிமிடங்களில் செய்யப்படுகிறது — மேலும் இது முன்பை விட மிகவும் தொழில்முறையாகத் தெரிகிறது.",
    feedback_a1_role: "செய்தி சேனல் உரிமையாளர், உத்தரபிரதேசம்",
    cta_title: "உங்கள் செய்தி சேனலை மாற்ற தயாராக உள்ளீர்களா?",
    cta_subtitle: "உங்கள் முதல் வீடியோவை 25 நிமிடங்களில் பெறுங்கள்.",
    cta_btn: "இன்றே தொடர்பு கொள்ளவும் — வரையறுக்கப்பட்ட இடங்கள் மட்டுமே உள்ளன.",
    footer_tagline: "அனந்தா இன்போடெக் — AI-இயங்கும் செய்திகள், விரைவான விநியோகம்.",
    footer_desc: "அதி யதார்த்தமான AI செய்தி தொகுப்பாளர்களுடன் அடுத்த தலைமுறை டிજிட்டல் செய்தி அறையை வலுப்படுத்துதல்.",
    footer_links: "விரைவான இணைப்புகள்",
    footer_contact: "தொடர்பு",
    footer_rights: "© 2026 அனந்தா இன்போடெக். அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை."
  },
  gu: {
    // Gujarati (ગુજરાતી)
    nav_tech: "ટેકનોલોજી",
    nav_samples: "નમૂનાઓ",
    nav_pricing: "પ્લાન્સ",
    nav_services: "સેવાઓ",
    nav_demo_btn: "ફ્રી ડેમો",
    nav_chat_wa: "વોટ્સએપ ચેટ",
    hero_title_prefix: "ના એન્કર, ના સ્ટુડિયો, ના એડિટર.",
    hero_title_suffix: "તમારી ન્યૂઝ ચેનલ, સંપૂર્ણપણે AI દ્વારા સંચાલિત.",
    hero_extra: "બ્રેકિંગ ન્યૂઝ 2 કલાકમાં નહીં, માત્ર 25 મિનિટમાં.",
    hero_tagline: "AI એન્કર સાથે પ્રોફેશનલ ન્યૂઝ વિડિઓઝ — તમારો ચહેરો, તમારો અવાજ, તમારી બ્રાન્ડ.",
    hero_subtext: "નેક્સ્ટ-જનરેશન AI એન્કર્સ સાથે તમારા ડિજિટલ ન્યૂઝરૂમમાં ક્રાંતિ લાવો.",
    hero_hindi_detail: "સ્ટુડિયો, કેમેરા કે હ્યુમન એન્કર વિના આજે જ તમારી ન્યૂઝ ચેનલ શરૂ કરો.",
    hero_btn_samples: "નમૂનાઓ જુઓ",
    hero_btn_pricing: "પ્રાઇસિંગ પ્લાન્સ",
    hero_ticker: " • સ્ટુડિયોની જરૂર નથી • 100+ ભાષાઓ ઉપલબ્ધ • 4K AI એન્કર તૈયાર • આજે જ ચેનલ શરૂ કરો • કેમેરાની જરૂર નથી • ",
    about_badge: "અમે શું કરીએ છીએ",
    about_title: "એન્કર વિના, સ્ટુડિયો વિના, એડિટર વિના આખી ન્યૂઝ ચેનલ ચલાવો.",
    about_title_accent: "સમાચારથી વિડિઓ સુધી માત્ર 25 મિનિટમાં.",
    about_sublead: "કોઈ સ્ટુડિયો નથી. કોઈ એન્કરનો પગાર નથી. કોઈ પ્રોડક્શનની માથાકૂટ નથી. યુટ્યુબ, ફેસબુક અને અન્ય પ્લેટફોર્મ પર પ્રકાશિત કરવા માટે તૈયાર.",
    about_vision_heading: "અમે માત્ર વિડિઓ બનાવતા નથી.",
    about_vision_span: "અમે સંપૂર્ણ ઓટોમેટેડ ડિજિટલ ન્યૂઝ ચેનલો બનાવીએ છીએ.",
    about_desc1: "અનંત ઇન્ફોટેક એ ન્યૂઝ એડિટિંગ એજન્સી છે જે આર્ટિફિશિયલ ઇન્ટેલિજન્સ (AI) દ્વારા સંચાલિત છે. અમે નાની અને સ્વતંત્ર ન્યૂઝ ચેનલોને પ્રોફેશનલ ક્વોલિટી વિડિઓઝ બનાવવામાં મદદ કરીએ છીએ — ઝડપી, સસ્તી અને કોઈ પ્રોડક્શન ટીમ વિના.",
    about_desc2: "તમારે સામાન્ય AI એન્કર સાથે દૈનિક ન્યૂઝ વિડિઓ જોઇએ કે તમારા જેવા જ દેખાતા અને બોલતા પર્સનલાઇઝ્ડ એન્કરની જરૂર હોય, અમે એડિટિંગથી લઈને ડિલિવરી સુધીનું બધું જ સંભાળીએ છીએ.",
    feat_ai_title: "અતિ-વાસ્તવિક AI એન્કર્સ",
    feat_ai_desc: "માનવ જેવા હાવભાવ અને સચોટ લિપ-sync સાથેના અત્યાધુનિક ન્યુરલ અવતાર.",
    feat_prod_title: "દૈનિક વિડિઓ ઉત્પાદન",
    feat_prod_desc: "દરરોજ તમારા ડેશબોર્ડ પર તાજા અને સંબંધિત સમાચાર વિડિઓઝ પહોંચાડવામાં આવે છે.",
    feat_vis_title: "પ્રોફેશનલ વિઝ્યુઅલ્સ",
    feat_vis_desc: "રાષ્ટ્રીય ટીવી ચેનલોને ટક્કર આપે તેવા વર્ચ્યુઅલ સ્ટુડિયો અને હાઇ-એન્ડ ન્યૂઝ ગ્રાફિક્સ.",
    feat_deliv_title: "ઝડપી ડિલિવરી",
    feat_deliv_desc: "સ્ક્રિપ્ટમાંથી સીધા બ્રોડકાસ્ટ-રેડી વિડિઓ મિનિટોમાં, કલાકોમાં નહીં.",
    feat_dep_title: "શૂન્ય નિર્ભરતા",
    feat_dep_desc: "એન્કર કે એડિટર માટે હવે કોઈ રાહ જોવાની જરૂર નથી. તમારી ચેનલ 24/7 ઓટોપાયલટ પર ચાલશે.",
    promo_badge: "તમારું સામ્રાજ્ય શરૂ કરો",
    promo_text: "ડિજિટલ પત્રકારત્વના ભવિષ્યમાં પગલું ભરો.",
    promo_btn: "શરૂ કરો",
    how_title: "તે કેવી રીતે કામ કરે છે",
    how_step1_title: "સામગ્રી મોકલો",
    how_step1_desc: "તમારું ફૂટેજ, ઓડિયો અને સ્ક્રિપ્ટ અમને મોકલો.",
    how_step2_title: "AI પ્રોસેસિંગ",
    how_step2_desc: "અમારી ટીમ અને AI સિસ્ટમ તમારી સામગ્રી પર પ્રક્રિયા અને સંપાદન કરે છે.",
    how_step3_title: "ઝડપી ડિલિવરી",
    how_step3_desc: "25 મિનિટમાં પ્રકાશિત કરવા માટે તૈયાર સમાચાર વિડિઓ તમારા સુધી પહોંચશે.",
    why_title: "શા માટે",
    why_accent: "અનંત?",
    why_subtitle: "કારણ કે તમારી સ્પર્ધા હજી પણ આ કામ મેન્યુઅલી કરી રહી છે.",
    why_old_badge: "જૂની મુશ્કેલીઓ",
    why_old_heading: "મેન્યુઅલ ઉત્પાદન",
    why_old_p1: "મોંઘા એન્કરો",
    why_old_p1_cost: "₹25k–₹50k/મહિનો",
    why_old_p2: "ઊંચો સ્ટુડિયો સેટઅપ ખર્ચ",
    why_old_p3: "ઉત્પાદન અને સંપાદનમાં વિલંબ",
    why_new_badge: "ઉત્તમ મૂલ્ય",
    why_new_heading: "અનંત AI પાવરહાઉસ",
    why_new_p1_title: "ઓછો ખર્ચ",
    why_new_p1_desc: "મોટા પગાર ખર્ચ વિના દૈનિક સમાચાર વિડિઓઝ. પ્લાન્સ ફક્ત ₹5,500/મહિનાથી શરૂ થાય છે.",
    why_new_p2_title: "સતત ઉત્પાદન",
    why_new_p2_desc: "હવે માણસોને લીધે વિલંબ નહીં. 24/7 વિશ્વસનીયતા.",
    why_new_p3_title: "સ્કેલેબલ ઉત્પાદન",
    why_new_p3_desc: "1 થી 100 વિડિઓ સુધી સરળતાથી ઉત્પાદન વધારો.",
    why_new_p4_title: "પ્રો બ્રાન્ડિંગ",
    why_new_p4_desc: "પહેલી જ સેકન્ડથી રાષ્ટ્રીય ટીવી જેવા વિઝ્યુઅલ્સ.",
    why_usp_point: "2 કલાકથી 25 મિનિટ — આ જ અમારો તફાવત છે. કોઈ સ્ટુડિયો સેટઅપની જરૂર નથી. કોઈ ફૂલ-ટાઇમ એડિટરની જરૂર નથી. તમારા પોતાના ચહેરો અને અવાજ સાથે AI એન્કર — ખૂબ જ ઓછા ખર્ચે ઉપલબ્ધ.",
    pricing_title: "અમારા",
    pricing_title_accent: "પ્રાઇસિંગ પ્લાન્સ",
    plan_standard_title: "Standard AI Anchor Plans",
    plan_standard_desc: "પ્રોફેશનલ ન્યૂઝ વિડિઓઝ ઉચ્ચ ગુણવત્તાવાળા AI એન્કર સાથે. કોઈ પ્રોડક્શન ટીમ રાખ્યા વિના સમાચારનું પ્રમાણ વધારવા માંગતા લોકો માટે.",
    plan_realface_title: "Real Face AI Anchor Plans",
    plan_realface_desc: "તમારો ચહેરો. તમારો અવાજ. AI એન્કરમાં ક્લોન કરેલ — જે દરેક વિડિઓમાં સ્ક્રીન પર તમારી ચેનલની ઓળખ બનશે.",
    plan_starter_name: "Starter Plan",
    plan_starter_price: "₹5,500",
    plan_starter_duration: "/ મહિનો",
    plan_starter_tagline: "સ્થાનિક અને વધતી જતી ડિજિટલ ચેનલો માટે આદર્શ",
    plan_starter_f1: "રોજ 3 વિડિઓ, દરેક 5 મિનિટ સુધી",
    plan_starter_f2: "પ્રોફેશનલ AI એન્કર",
    plan_starter_f3: "ન્યૂઝ વિઝ્યુઅલ્સ ઇન્ટિગ્રેશન",
    plan_starter_f4: "કસ્ટમ બ્રાન્ડિંગ અને HD આઉટપુટ",
    plan_growth_name: "Growth Plan",
    plan_growth_price: "₹10,000",
    plan_growth_duration: "/ મહિનો",
    plan_growth_tagline: "રોજ અનેક અપડેટ્સ પ્રકાશિત કરતી ચેનલો માટે",
    plan_growth_f1: "રોજ 6 વિડિઓ, દરેક 5 મિનિટ સુધી",
    plan_growth_f2: "પ્રાયોરિટી પ્રોસેસિંગ અને ઝડપી ડિલિવરી",
    plan_growth_f3: "ન્યૂઝ વિઝ્યુઅલ્સ ઇન્ટિગ્રેશન",
    plan_growth_f4: "કસ્ટમ બ્રાન્ડિંગ અને HD આઉટપુટ",
    plan_personal_name: "Personal AI Anchor",
    plan_personal_price: "₹7,500",
    plan_personal_duration: "/ મહિનો",
    plan_personal_tagline: "તમારા પોતાના ચહેરા અને અવાજને પ્રોફેશનલ AI પ્રેઝેન્ટરમાં બદલો",
    plan_personal_f1: "રોજ 3 વિડિઓ, દરેક 5 મિનિટ સુધી",
    plan_personal_f2: "તમારો ફેસ ક્લોન",
    plan_personal_f3: "તમારો વોઇસ ક્લોન",
    plan_personal_f4: "કસ્ટમ બ્રાન્ડિંગ અને HD આઉટપુટ",
    plan_premium_personal_name: "Premium Personal AI Anchor",
    plan_premium_personal_price: "₹13,000",
    plan_premium_personal_duration: "/ મહિનો",
    plan_premium_personal_tagline: "પર્સનલાઇઝ્ડ AI ઓળખ સાથે હાઇ-વોલ્યુમ ઉત્પાદન",
    plan_premium_personal_f1: "રોજ 6 વિડિઓ, દરેક 5 મિનિટ સુધી",
    plan_premium_personal_f2: "તમારો ફેસ અને વોઇસ ક્લોન",
    plan_premium_personal_f3: "પ્રાયોરિટી પ્રોસેસિંગ અને સમર્પિત સપોર્ટ",
    plan_premium_personal_f4: "સમર્પિત સપોર્ટ અને HD આઉટપુટ",
    plan_custom_name: "કસ્ટમ / એન્ટરપ્રાઇઝ",
    plan_custom_desc: "વધુ વિડિઓ જોઈએ છે? મીડિયા હાઉસ, ડિજિટલ પ્રકાશકો, રાજકીય સંગઠનો અને કન્ટેન્ટ નેટવર્ક માટે કસ્ટમ એન્ટરપ્રાઇઝ પ્લાન્સ ઉપલબ્ધ છે.",
    plan_custom_btn: "સંપર્ક કરો",
    app_badge: "ટૂંક સમયમાં આવી રહ્યું છે",
    app_title: "News Editor App",
    app_desc1: "તમારી સામગ્રી પર પૂર્ણ નિયંત્રણ મેળવો. અમારી AI-સંચાલિત એપ્લિકેશન ન્યૂઝ ચેનલના માલિકોને રેડીમેડ નમૂનાઓનો ઉપયોગ કરીને પોતાના વિડિઓ બનાવવાની અને પ્રકાશિત કરવાની મંજૂરી આપે છે — કોઈ તકનીકી કુશળતાની જરૂર નથી.",
    app_desc2: "તમારો ઓડિયો, ફૂટેજ અને હેડિંગ અપલોડ કરો. એપ્લિકેશન આપમેળે પ્રકાશિત કરવા માટે તૈયાર સમાચાર વિડિઓ જનરેટ કરે છે.",
    app_price_tag: "ફક્ત ₹1,000/મહિનાના દરે લોન્ચ થશે.",
    app_btn: "સૂચના મેળવો",
    feedback_badge: "સફળતાની વાર્તાઓ",
    feedback_title: "વિશ્વાસ",
    feedback_title_accent: "ડિજિટલ ન્યૂઝરૂમ્સનો",
    feedback_q1: "અમે દરેક ન્યૂઝ વિડિઓ પર 2 કલાકથી વધુ સમય વિતાવતા હતા. હવે તે 25 મિનિટમાં થઈ જાય છે — અને તે પહેલા કરતાં વધુ વ્યવસાયિક લાગે છે.",
    feedback_a1_role: "ન્યૂઝ ચેનલ માલિક, ઉત્તર પ્રદેશ",
    cta_title: "તમારી ન્યૂઝ ચેનલને બદલવા માટે તૈયાર છો?",
    cta_subtitle: "તમારો પ્રથમ વિડિઓ 25 મિનિટમાં મેળવો.",
    cta_btn: "આજે જ સંપર્ક કરો — મર્યાદિત સ્લોટ્સ જ ઉપલબ્ધ છે.",
    footer_tagline: "અનંત ઇન્ફોટેક — AI સંચાલિત સમાચાર, ઝડપી વિતરણ.",
    footer_desc: "અતિ વાસ્તવિક AI એન્કર્સ સાથે આગામી પેઢીના ડિજિટલ ન્યૂઝરૂમને સશક્ત બનાવવું.",
    footer_links: "ઝડપી લિંક્સ",
    footer_contact: "સંપર્ક",
    footer_rights: "© 2026 અનંત ઇન્ફોટેક. તમામ હકો અબાધિત છે."
  }
};
